"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7356],{

/***/ 84012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SignInModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45046);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32701);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10684);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);






function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// import './signInModal.scss'
var config = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])().publicRuntimeConfig;
var LoginModule = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.lazy(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5382), __webpack_require__.e(1608), __webpack_require__.e(1951)]).then(__webpack_require__.t.bind(__webpack_require__, 19327, 23));
});
var SignInModal = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(SignInModal, _Component);
    var _super = _createSuper(SignInModal);
    function SignInModal(props) {
        _classCallCheck(this, SignInModal);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "toggleEmail", function() {
            _this.setState({
                emailOpen: !_this.state.emailOpen
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onLoginSuccess", function(res1) {
            var _props = _this.props, _csrf = _props._csrf, identifier = _props.identifier;
            var token = res1.token;
            res1.token && localStorage.setItem("CF_BEARER_TOKEN", token);
            if (window.location.search) {
                var ref;
                var queryString = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search;
                var urlParams = new URLSearchParams(queryString);
                var UpdateIdfromUrl = urlParams.get('updateId');
                var DonationIdfromUrl = urlParams.get('donationId');
                var ProgramIdfromUrl = urlParams.get('programId');
                sessionStorage.getItem("UpdateIdfromUrl") === null ? sessionStorage.setItem("UpdateIdfromUrl", UpdateIdfromUrl) : null;
                sessionStorage.setItem("DonationIdfromUrl", DonationIdfromUrl);
                sessionStorage.getItem("ProgramIdfromUrl") === null ? sessionStorage.setItem("ProgramIdfromUrl", ProgramIdfromUrl) : null;
            }
            if (!identifier) {
                axios__WEBPACK_IMPORTED_MODULE_2___default()({
                    method: 'post',
                    url: "/validate-signin",
                    data: {
                        data: res1,
                        _csrf: _csrf
                    }
                }).then(function(res) {
                    if (window.eventDispatcher) {
                        window.eventDispatcher.dispatchEventSync('loginSuccess', {
                            method: 'email-password'
                        }, {
                            amplitude: true
                        });
                    }
                    window.location.reload();
                }).catch(function(error) {
                    _this.setState({
                        userLoggedIn: false
                    });
                // TODO: Throw error message 
                });
            } else {
                axios__WEBPACK_IMPORTED_MODULE_2___default()({
                    method: 'post',
                    url: '/verify-email',
                    data: {
                        email: res1.user.email,
                        emailVerified: true,
                        phone: res1.user.phone,
                        _csrf: _csrf
                    },
                    withCredentials: true
                }).then(function(res, err) {
                    if (err || res.error) {
                    // TODO: Do Nothing
                    } else {
                        window.location.reload();
                    }
                }).catch(function(error) {
                    if (_this.props && _this.props.onError) {
                        _this.props.onError({
                            message: "Email is linked to another user. Please try again with a different email or login to a different account."
                        });
                    }
                    return;
                });
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onLoginFailure", function(res) {
        // window.location.reload()
        });
        _defineProperty(_assertThisInitialized(_this), "loginMethods", [
            'EMAIL-OTP',
            'PHONE-OTP',
            'EMAIL-PASSWORD',
            'PHONE-PASSWORD',
            'SOCIAL-FACEBOOK',
            'SOCIAL-GOOGLE', 
        ]);
        _defineProperty(_assertThisInitialized(_this), "availableDomains", [
            '*'
        ]);
        _this.state = {
            emailOpen: false,
            userLoggedIn: false
        };
        return _this;
    }
    _createClass(SignInModal, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        autoFocus: true,
                        isOpen: this.props.isOpen,
                        toggle: function() {
                            return _this.props.toggleSignUpOpen();
                        },
                        className: "sign-up-modal",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                style: {
                                    paddingBottom: '0'
                                },
                                toggle: this.props.toggleSignUpOpen
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                style: {
                                    paddingTop: '0',
                                    paddingBottom: '0'
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                                    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: "Loading..."
                                    }),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoginModule, {
                                        onSuccess: function(e) {
                                            return _this.onLoginSuccess(e);
                                        },
                                        onFailure: function(e) {
                                            return _this.onLoginFailure(e);
                                        },
                                        googleClientID: config.google_id,
                                        OTPLength: 4,
                                        telCountryCode: "IN",
                                        loginMethods: this.loginMethods,
                                        availableDomains: this.availableDomains,
                                        identifier: this.props.identifier || false,
                                        baseURL: config.fundraisersPlatformUrl
                                    })
                                })
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return SignInModal;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ }),

/***/ 44106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function FontAwesomeSVGIcon(props) {
    var icon = props.icon;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 ".concat(icon.icon[0], " ").concat(icon.icon[1]),
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        focusable: "false",
        "aria-hidden": "true",
        "data-prefix": icon.prefix,
        "data-icon": icon.iconName,
        className: props.className,
        width: props.width,
        height: props.height,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: props.color,
            className: props.fillClassName,
            d: icon.icon[4]
        })
    }));
}
FontAwesomeSVGIcon.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
        prefix: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        iconName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        icon: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array.isRequired)
    }).isRequired,
    width: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    fillClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
FontAwesomeSVGIcon.defaultProps = {
    className: '',
    color: 'currentColor',
    fillClassName: ''
};
/* harmony default export */ __webpack_exports__["Z"] = (FontAwesomeSVGIcon);


/***/ }),

/***/ 14230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: _objectSpread({}, props.style),
        className: props.className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: props.width || props.size,
            height: props.height || props.size,
            viewBox: "0 0 47.94 47.94",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                style: {
                    fill: '#008c8c'
                },
                d: "M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757 c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042 c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685 c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528 c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956 C22.602,0.567,25.338,0.567,26.285,2.486z"
            })
        })
    }));
};


/***/ }),

/***/ 67130:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/*
* Component designed to help select one or more components that match a given selection criteria
* The default selection criteria is if the name of the component matches the desired name
*
* Example usage : Selecting versions during AB experiments
*
* We can provide a fallback component which will be triggered if none of the components match the criteria
*
*
* */ var defaultKeyName = 'name';
var renderFallback = function(fallback) {
    return typeof fallback !== 'undefined' ? fallback : null;
};
var SelectComponent = function(_param) {
    var children1 = _param.children, fallback = _param.fallback, criteria = _param.criteria, keyName = _param.keyName, props = _objectWithoutProperties(_param, [
        "children",
        "fallback",
        "criteria",
        "keyName"
    ]);
    var selectedKeyName = keyName || defaultKeyName;
    var key1 = props[selectedKeyName];
    if (typeof key1 === 'undefined' || typeof children1 === 'undefined') {
        return renderFallback(fallback);
    }
    var defaultCriteria = function(children, key) {
        return children.filter(function(child) {
            return child.props[selectedKeyName] === key;
        });
    };
    var selectedCriteria = typeof criteria === 'undefined' ? defaultCriteria : criteria;
    var selected = selectedCriteria(children1, key1);
    if (selected.length === 0) {
        return renderFallback(fallback);
    }
    return selected;
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectComponent);


/***/ }),

/***/ 17356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ siteChrome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/colors.js
var colors = __webpack_require__(50386);
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);
// EXTERNAL MODULE: ./components/chrome/elements/icons/facebookIcon.js
var facebookIcon = __webpack_require__(98503);
// EXTERNAL MODULE: ./components/chrome/elements/icons/twitterIcon.js
var twitterIcon = __webpack_require__(19146);
// EXTERNAL MODULE: ./components/chrome/elements/icons/instagramIcon.js
var instagramIcon = __webpack_require__(92341);
// EXTERNAL MODULE: ./components/chrome/elements/icons/linkedinIcon.js
var linkedinIcon = __webpack_require__(70811);
// EXTERNAL MODULE: ./components/chrome/elements/buttons/index.js + 4 modules
var buttons = __webpack_require__(31152);
// EXTERNAL MODULE: ./components/chrome/elements/noSSR.js
var noSSR = __webpack_require__(2087);
;// CONCATENATED MODULE: ./components/chrome/layout/newFooter/footer.js









function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// import './footer.scss';
var _getLocalStore = function(name) {
    try {
        return JSON.parse(localStorage.getItem(name));
    } catch (err) {
        return null;
    }
};
// const homelinksData = [
// 	{ heading: 'About Us', src: '/aboutus', rel: null, target: null },
// 	{
// 		heading: 'Give India Fundraisers',
// 		src: 'https://fundraisers.giveindia.org',
// 		rel: 'noopener noreferrer',
// 		target: '_blank'
// 	},
// 	{
// 		heading: 'Workplace Giving',
// 		src: 'https://workplace.giveindia.org/',
// 		rel: 'noopener noreferrer',
// 		target: '_blank'
// 	},
// 	{
// 		heading: 'Partner NGOs',
// 		src: '/certified-indian-ngos',
// 		rel: null,
// 		target: null
// 	},
// 	{ heading: 'NGOs in India', src: '/all-ngos/', rel: null, target: null },
// 	{
// 		heading: 'Previous platform',
// 		src: 'https://gi.giveindia.org/',
// 		rel: 'noopener noreferrer',
// 		target: '_blank'
// 	},
// 	{ heading: 'Give Assured', src: '/giveassured', rel: null, target: null },
// 	{ heading: 'Blogs', src: '/blog', rel: null, target: null },
// 	{ heading: 'Careers', src: '/careers', rel: null, target: '_blank' },
// 	{
// 		heading: 'Help',
// 		src: 'https://support.giveindia.org/support/home',
// 		rel: null,
// 		target: '_blank'
// 	},
// 	{ heading: 'Contact Us', src: '/contactus', rel: null, target: '_blank' }
// ];
var homelinksData = [
    {
        type: 'getToKnow',
        name: 'Get to know us',
        list: [
            {
                heading: 'About Us',
                src: '/aboutus',
                rel: null,
                target: null
            },
            {
                heading: 'Careers',
                src: '/careers',
                rel: null,
                target: '_blank'
            },
            {
                heading: 'Blog',
                src: '/blog/',
                rel: null,
                target: '_blank'
            },
            {
                heading: 'Legal & Financials',
                src: '/aboutus#legal',
                rel: null,
                target: '_blank'
            }
        ]
    },
    {
        type: 'connectWithUs',
        name: 'Connect with us',
        list: [
            {
                heading: 'Contact Us',
                src: '/contactus',
                rel: null,
                target: '_blank'
            },
            {
                heading: 'Help Center',
                src: 'https://support.giveindia.org/support/home',
                rel: null,
                target: '_blank'
            },
            {
                heading: 'Newsletter',
                src: '/newsletters',
                rel: null,
                target: '_blank'
            }
        ]
    },
    {
        type: 'getInvolved',
        name: 'Get Involved',
        list: [
            {
                heading: 'Corporate Partnerships',
                src: 'https://workplace.giveindia.org/',
                rel: null,
                target: '_blank'
            },
            {
                heading: 'Brand & Retail Partnerships',
                src: 'https://partnerships.giveindia.org/',
                rel: null,
                target: '_blank'
            },
            {
                heading: 'Fundraise',
                src: 'https://fundraisers.giveindia.org/start-a-campaign',
                rel: 'noopener noreferrer',
                target: '_blank'
            },
            {
                heading: 'Institutional Giving',
                src: 'https://institutionalgiving.giveindia.org/',
                rel: 'noopener noreferrer',
                target: '_blank'
            }
        ]
    },
    {
        type: 'donate',
        name: 'Donate',
        list: [
            {
                heading: 'Monthly Giving',
                src: '/monthly',
                rel: null,
                target: '_blank'
            },
            {
                heading: 'Fundraisers',
                src: 'https://fundraisers.giveindia.org/',
                rel: 'noopener noreferrer',
                target: '_blank'
            },
            {
                heading: 'COVID Missions',
                src: 'https://covid.giveindia.org',
                rel: 'noopener noreferrer',
                target: '_blank'
            }
        ]
    }, 
];
var Footer = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Footer, Component1);
    var _super = _createSuper(Footer);
    function Footer(props) {
        _classCallCheck(this, Footer);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "toggleButton", function() {
            var currency = _this.state.toggle ? 'INR' : 'USD';
            _this.setState({
                toggle: !_this.state.toggle
            });
            _this.changeCurrentCurrency(currency);
        });
        _defineProperty(_assertThisInitialized(_this), "changeCurrentCurrency", function(e) {
            localStorage.setItem('currentCurrency', JSON.stringify(e));
            localStorage.setItem('isCurrencyChanged', true);
            // TODO Add case to handle US and USA here.
            _this.setState({
                currency: e
            });
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEventSync('currencyToggle', {}, {
                    amplitude: true
                });
            }
            window.location.reload();
        });
        _this.state = {
            missionsData: [],
            causesData: [],
            currency: 'INR',
            toggle: false
        };
        return _this;
    }
    _createClass(Footer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var ref, ref1;
                var session = this.props.session;
                if ((ref = this.props.tenantConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.header) === null || ref1 === void 0 ? void 0 : ref1.menuLinks) {
                    var missionsData = this.props.tenantConfig.header.menuLinks.filter(function(item) {
                        return item.heading === 'Missions';
                    });
                    if (missionsData.length > 0) {
                        this.setState({
                            missionsData: missionsData[0].missions
                        });
                    }
                    var causesData = this.props.tenantConfig.header.menuLinks.filter(function(item) {
                        return item.heading !== 'Missions' && item.heading !== 'Support Covid Missions';
                    });
                    if (causesData.length > 0) {
                        this.setState({
                            causesData: causesData
                        });
                    }
                }
                var currentCurrency = 'INR';
                var localStoreCurrency = _getLocalStore('currentCurrency');
                if (localStoreCurrency) {
                    currentCurrency = localStoreCurrency;
                } else if (session && session.currentCurrency) {
                    currentCurrency = session.currentCurrency;
                } else if (session && session.country) {
                    currentCurrency = session.country;
                }
                if (currentCurrency === 'INR' || currentCurrency === 'IN') {
                    this.setState({
                        currency: 'INR',
                        toggle: false
                    });
                } else {
                    this.setState({
                        currency: 'USD',
                        toggle: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _state = this.state, missionsData = _state.missionsData, causesData = _state.causesData;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "homescreen-footer",
                    id: "footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hs-footer-box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hs-footer-homelinks",
                                    children: homelinksData.map(function(item, idx) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "hs-footer-hl-list",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hs-footer-hl-list-heading",
                                                    children: item.name
                                                }),
                                                item.list.map(function(subItem, subIdx) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "hs-footer-hl-list-item",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: subItem.src,
                                                            target: subItem.target,
                                                            rel: subItem.rel,
                                                            children: subItem.heading
                                                        })
                                                    }, subIdx));
                                                })
                                            ]
                                        }, idx));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hs-footer-social-currency",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(noSSR/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hs-footer-currency-input",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* ToggleButton */.CO, {
                                                    toggleButton: this.toggleButton,
                                                    toggle: this.state.toggle,
                                                    classNames: this.state.toggle ? 'btn btn-toggle active no-hover' : 'btn btn-toggle no-hover'
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hs-footer-social",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "hs-footer-social-icons",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            rel: "noopener noreferrer",
                                                            href: "https://www.facebook.com/GiveIndia/",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebookIcon/* default */.Z, {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                },
                                                                size: 20,
                                                                color: "".concat((colors_default()).giveMidGrey)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            rel: "noopener noreferrer",
                                                            href: "https://twitter.com/giveindia/",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitterIcon/* default */.Z, {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                },
                                                                size: 20,
                                                                color: "".concat((colors_default()).giveMidGrey)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            rel: "noopener noreferrer",
                                                            href: "https://www.instagram.com/give_india/",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagramIcon/* default */.Z, {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                },
                                                                size: 20,
                                                                color: "".concat((colors_default()).giveMidGrey)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            rel: "noopener noreferrer",
                                                            href: "https://www.linkedin.com/company/giveindia/",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedinIcon/* default */.Z, {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                },
                                                                size: 20,
                                                                color: "".concat((colors_default()).giveMidGrey)
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hs-footer-bottom-bar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hs-footer-bb-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "hs-footer-bottom-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hs-footer-bottom-left-logo",
                                                children: "\xa9 GiveIndia"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hs-footer-bottom-left-text",
                                                children: "Donations through this platform are tax exempted under 80G & 501(c)(3)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "hs-footer-bottom-right",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "no-hover-a",
                                                    href: "/terms",
                                                    children: "Terms"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "no-hover-a",
                                                    href: "/privacy",
                                                    children: "Privacy Policy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/sitemap",
                                                    children: "Site Map"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return Footer;
}(react.Component);


;// CONCATENATED MODULE: ./components/chrome/layout/newFooter/index.js


// EXTERNAL MODULE: ./node_modules/reactstrap/es/Dropdown.js
var Dropdown = __webpack_require__(86704);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/DropdownToggle.js
var DropdownToggle = __webpack_require__(65497);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/DropdownMenu.js
var DropdownMenu = __webpack_require__(42365);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/DropdownItem.js
var DropdownItem = __webpack_require__(98227);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Button.js
var Button = __webpack_require__(97975);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Navbar.js
var Navbar = __webpack_require__(9544);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/NavbarToggler.js
var NavbarToggler = __webpack_require__(35614);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Nav.js
var Nav = __webpack_require__(77243);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/NavLink.js
var NavLink = __webpack_require__(98008);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Popover.js
var Popover = __webpack_require__(46073);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/PopoverBody.js
var PopoverBody = __webpack_require__(68103);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Container.js
var Container = __webpack_require__(98595);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Row.js
var Row = __webpack_require__(10267);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Col.js
var Col = __webpack_require__(51252);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(67265);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
var react_responsive_default = /*#__PURE__*/__webpack_require__.n(react_responsive);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./util/cookies.js
var cookies = __webpack_require__(69721);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/chrome/layout/newHeader/signoutButton.js






function signoutButton_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function signoutButton_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function signoutButton_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function signoutButton_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) signoutButton_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) signoutButton_defineProperties(Constructor, staticProps);
    return Constructor;
}
function signoutButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signoutButton_getPrototypeOf(o) {
    signoutButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return signoutButton_getPrototypeOf(o);
}
function signoutButton_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) signoutButton_setPrototypeOf(subClass, superClass);
}
function signoutButton_possibleConstructorReturn(self, call) {
    if (call && (signoutButton_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return signoutButton_assertThisInitialized(self);
}
function signoutButton_setPrototypeOf(o, p) {
    signoutButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return signoutButton_setPrototypeOf(o, p);
}
var signoutButton_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function signoutButton_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function signoutButton_createSuper(Derived) {
    var hasNativeReflectConstruct = signoutButton_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = signoutButton_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = signoutButton_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return signoutButton_possibleConstructorReturn(this, result);
    };
}
var signoutButton_config = (0,config["default"])().publicRuntimeConfig;
var dropdownStyle = {
    textAlign: 'left',
    cursor: 'pointer'
};
var SignoutButton = /*#__PURE__*/ function(_Component) {
    "use strict";
    signoutButton_inherits(SignoutButton, _Component);
    var _super = signoutButton_createSuper(SignoutButton);
    function SignoutButton() {
        signoutButton_classCallCheck(this, SignoutButton);
        var _this;
        _this = _super.apply(this, arguments);
        signoutButton_defineProperty(signoutButton_assertThisInitialized(_this), "handleSignoutSubmit", function(event) {
            event.preventDefault();
            cookies/* default.delete */.Z["delete"](signoutButton_config.giveCookie);
            axios_default()({
                method: 'post',
                url: "/auth/signout",
                data: {
                    _csrf: _this.props._csrf
                }
            }).then(function(response) {
                window.location.href = window.location.href;
                cookies/* default.delete */.Z["delete"]('GI_TOKEN');
                localStorage.removeItem("CF_BEARER_TOKEN");
            });
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEventSync('logout', {}, {
                    amplitude: true
                });
            }
            return false;
        });
        return _this;
    }
    signoutButton_createClass(SignoutButton, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                    href: "#",
                    onClick: this.handleSignoutSubmit,
                    children: "Sign Out"
                }));
            }
        }
    ]);
    return SignoutButton;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-autosuggest/dist/index.js
var dist = __webpack_require__(58808);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/react-contextual/dist/react-contextual.es.js
var react_contextual_es = __webpack_require__(80224);
// EXTERNAL MODULE: ./components/chrome/elements/icons/star.js
var star = __webpack_require__(14230);
// EXTERNAL MODULE: ./util/dataFetcher.js
var dataFetcher = __webpack_require__(21101);
// EXTERNAL MODULE: ./components/workplace/common/selectByPlatform.js
var selectByPlatform = __webpack_require__(93220);
;// CONCATENATED MODULE: ./components/search/newQuickSearch.js












function newQuickSearch_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function newQuickSearch_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function newQuickSearch_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function newQuickSearch_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) newQuickSearch_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) newQuickSearch_defineProperties(Constructor, staticProps);
    return Constructor;
}
function newQuickSearch_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function newQuickSearch_getPrototypeOf(o) {
    newQuickSearch_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return newQuickSearch_getPrototypeOf(o);
}
function newQuickSearch_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) newQuickSearch_setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            newQuickSearch_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function newQuickSearch_possibleConstructorReturn(self, call) {
    if (call && (newQuickSearch_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return newQuickSearch_assertThisInitialized(self);
}
function newQuickSearch_setPrototypeOf(o, p) {
    newQuickSearch_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return newQuickSearch_setPrototypeOf(o, p);
}
var newQuickSearch_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function newQuickSearch_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function newQuickSearch_createSuper(Derived) {
    var hasNativeReflectConstruct = newQuickSearch_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = newQuickSearch_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = newQuickSearch_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return newQuickSearch_possibleConstructorReturn(this, result);
    };
}
var newQuickSearch_config = (0,config["default"])().publicRuntimeConfig;
var tags = [];
var tagsMap = {};
var tagsTypeWeights = {
    cause: 1,
    'sub-cause': 2,
    location: 3,
    ngo: 5
};
var recommendedCause = [
    'The Akshaya Patra Foundation',
    'Goonj',
    'HelpAge India',
    'Girl Child',
    'Cancer'
];
var getSuggestions = function(value) {
    var popularTags = tags.filter(function(tag) {
        return tag.type.indexOf('cause') === 0;
    });
    var inputValue = value.trim().toLowerCase();
    var inputLength = inputValue.length;
    if (inputLength === 0) {
        return [];
    }
    var startsWithMatches = tags.filter(function(tag) {
        return tag.value.toLowerCase().startsWith(inputValue);
    }).sort(function(a, b) {
        return tagsTypeWeights[a.type] * a.value.length - tagsTypeWeights[b.type] * b.value.length;
    });
    var includesMatches = tags.filter(function(tag) {
        return tag.value.toLowerCase().includes(inputValue);
    }).sort(function(a, b) {
        return tagsTypeWeights[a.type] * a.value.length - tagsTypeWeights[b.type] * b.value.length;
    });
    var causeMatchesArray = [];
    var ngoMatchesArray = [];
    var locationMatchesArray = [];
    var programMatchesArray = [];
    var categoriesMatchesArray = [];
    var usableMatches = startsWithMatches.concat(includesMatches.slice(0, 5));
    var matchesToShow = [];
    var matchSeen = {};
    for(var i = 0; i < usableMatches.length; i++){
        var value1 = usableMatches[i].value.toLowerCase();
        if (!matchSeen[value1]) {
            matchesToShow.push(usableMatches[i]);
            matchSeen[value1] = true;
        }
    }
    for(var i1 = 0; i1 < matchesToShow.length; i1++){
        if (matchesToShow[i1].type === 'cause' || matchesToShow[i1].type === 'sub-cause' || matchesToShow[i1].type === 'tag1' || matchesToShow[i1].type === 'tag2') causeMatchesArray.push(matchesToShow[i1]);
        else if (matchesToShow[i1].type === 'ngo') ngoMatchesArray.push(matchesToShow[i1]);
        else if (matchesToShow[i1].type === 'location') locationMatchesArray.push(matchesToShow[i1]);
        else if (matchesToShow[i1].type === 'program') programMatchesArray.push(matchesToShow[i1]);
        else categoriesMatchesArray.push(matchesToShow[i1]);
    }
    var suggestionsArray = [];
    if (causeMatchesArray.length > 0) suggestionsArray.push({
        title: 'Cause',
        suggestions: causeMatchesArray
    });
    if (ngoMatchesArray.length > 0) suggestionsArray.push({
        title: 'NGO',
        suggestions: ngoMatchesArray
    });
    if (locationMatchesArray.length > 0) suggestionsArray.push({
        title: 'Location',
        suggestions: locationMatchesArray
    });
    if (programMatchesArray.length > 0) suggestionsArray.push({
        title: 'Programs',
        suggestions: programMatchesArray
    });
    if (categoriesMatchesArray.length > 0) suggestionsArray.push({
        title: 'Categories',
        suggestions: categoriesMatchesArray
    });
    if (matchesToShow.length === 0) suggestionsArray.push({
        title: "Oops! We couldn't find any results. Try these...",
        suggestions: popularTags
    });
    return suggestionsArray.map(function(section) {
        return {
            title: section.title,
            suggestions: section.suggestions.filter(function(suggestion) {
                return suggestion.value;
            })
        };
    }).filter(function(section) {
        return section.suggestions.length > 0;
    });
};
var getSuggestionValue = function(suggestion) {
    return suggestion.value;
};
var renderSuggestion = function(suggestion) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        children: suggestion.value
    });
};
var renderSectionTitle = function(section) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            style: {
                fontSize: '0.75rem'
            },
            children: [
                " \xa0 ",
                section.title,
                " "
            ]
        })
    });
};
var getSectionSuggestions = function(section) {
    return section.suggestions;
};
var QuickSearch = /*#__PURE__*/ function(_Component) {
    "use strict";
    newQuickSearch_inherits(QuickSearch, _Component);
    var _super = newQuickSearch_createSuper(QuickSearch);
    function QuickSearch(props) {
        newQuickSearch_classCallCheck(this, QuickSearch);
        var _this;
        _this = _super.call(this, props);
        var _this1 = newQuickSearch_assertThisInitialized(_this);
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "componentDidMount", _asyncToGenerator(runtime_default().mark(function _callee() {
            var searchTags, it;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return dataFetcher/* default.getAllSearchTags */.Z.getAllSearchTags();
                    case 3:
                        searchTags = _ctx.sent;
                        _this1.setState({
                            searchTags: searchTags
                        });
                        tags = uniqBy_default()(searchTags.tags, 'tag');
                        for(it = 0; it < tags.length; it++){
                            if (tags[it].tag !== undefined && tags[it].tag !== 'undefined') {
                                if (!tagsMap[tags[it].tag]) {
                                    tagsMap[tags[it].tag] = tags[it];
                                }
                            }
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log('error while fetching searchTags', _ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        })));
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "redirectToCampaign", function() {
            window.location.href = '/campaign/mission-10-million-meals';
        });
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "onSuggestionsFetchRequested", function(param) {
            var value = param.value;
            _this.setState({
                suggestions: getSuggestions(value)
            });
        });
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "onSuggestionSelected", function(event, param) {
            var suggestion = param.suggestion;
            _this.updateUrl([
                suggestion
            ], 'relevance');
        });
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "updateUrl", function(tags1, type) {
            var search = '';
            if (tags1 && tags1.length > 0) {
                var terms = [];
                for(var i = 0; i < tags1.length; i++){
                    terms.push(tags1[i].value);
                }
                search += 'tag=' + encodeURIComponent(terms.join('|'));
            }
            if (type) {
                if (search.length > 0) {
                    search += '&';
                }
                search += "type=".concat(type);
            }
            window.location.href = "/search?".concat(search);
        });
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "onRecommendedTagSelected", function(event, obj) {
            _this.onSuggestionSelected(event, {
                suggestion: obj
            });
        });
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "renderInputComponent", function(inputProps) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "new-input-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(newQuickSearch_config.cdnUrl, "/static/icons/search.svg"),
                        className: "new-icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, inputProps))
                ]
            });
        });
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "onChange", function(event, param) {
            var newValue = param.newValue;
            _this.setState({
                value: newValue
            });
        });
        newQuickSearch_defineProperty(newQuickSearch_assertThisInitialized(_this), "handleTagClick", function(e, val) {
            window.location.href = "/search?tag=".concat(val);
        });
        var urlTags = [];
        _this.state = {
            value: '',
            suggestions: [],
            searchTags: []
        };
        return _this;
    }
    newQuickSearch_createClass(QuickSearch, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, tenantConfig = _props.tenantConfig, placeholder = _props.placeholder, hideRecommendations = _props.hideRecommendations;
                var inputProps = {
                    placeholder: placeholder,
                    value: this.state.value,
                    onChange: this.onChange
                };
                var tenantRecommendedCause = tenantConfig && tenantConfig.search ? tenantConfig.search.recommendedCause : recommendedCause;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "search-box-quicksearch d-flex f-d-col",
                    id: "searchBox-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            style: {
                                padding: '0px'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                className: "search-box w-100",
                                multiSection: true,
                                suggestions: this.state.suggestions,
                                onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
                                getSuggestionValue: getSuggestionValue,
                                renderSuggestion: renderSuggestion,
                                renderSectionTitle: renderSectionTitle,
                                getSectionSuggestions: getSectionSuggestions,
                                inputProps: inputProps,
                                onSuggestionSelected: this.onSuggestionSelected,
                                highlightFirstSuggestion: true,
                                renderInputComponent: this.renderInputComponent
                            })
                        }),
                        !hideRecommendations && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "d-flex col-md-12 my-2 pl-0",
                            children: tenantRecommendedCause.map(function(item, idx) {
                                var _this2 = _this;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "recommandation-box-quickSearch",
                                    onClick: function(e) {
                                        return _this2.handleTagClick(e, item);
                                    },
                                    children: item
                                }, idx));
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return QuickSearch;
}(react.Component);
/* harmony default export */ var newQuickSearch = ((0,react_contextual_es/* subscribe */.Ld)()(QuickSearch));

;// CONCATENATED MODULE: ./components/chrome/elements/icons/searchIcon.js


function searchIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function searchIcon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            searchIcon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/* harmony default export */ function searchIcon(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: searchIcon_objectSpread({}, props.style),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            viewBox: "0 0 451 451",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: props.color,
                stroke: props.stroke,
                strokeWidth: props.strokeWidth,
                d: "M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3 s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4 C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3 s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z"
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/chrome/layout/header/GiNavToggler.js



var GiNavToggler_config = (0,config["default"])().publicRuntimeConfig;
var handleNavLinkClick = function handleNavLinkClick(pageType) {
    window.location.href = pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers' ? '/' : '/monthly';
};
var GiNavToggler = function(param) {
    var logo = param.logo, pageType = param.pageType;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "d-flex",
        onClick: function() {
            return handleNavLinkClick(pageType);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                logo === 'white' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers' ? "".concat(GiNavToggler_config.cdnUrl, "/static/giveindia-white.svg") : "".concat(GiNavToggler_config.cdnUrl, "/static/images/give-monthly-giving-white-2x.png"),
                    height: "30",
                    alt: ""
                }) : null,
                logo === 'black' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: pageType === 'homepage' || pageType === 'aboutus' || pageType === 'contactus' || pageType === 'newsletters' || pageType === 'terms' || pageType === 'privacy' || pageType === 'sitemap' || pageType === 'giveassured' || pageType === 'careers' ? "".concat(GiNavToggler_config.cdnUrl, "/static/images/giveindia-logo-color-transparent.png") : "".concat(GiNavToggler_config.cdnUrl, "/static/images/give-monthly-giving-2x.png"),
                    height: "30",
                    alt: ""
                }) : null,
                logo !== 'black' && logo !== 'white' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: pageType === 'homepage' || pageType === 'aboutus' || pageType === 'contactus' || pageType === 'newsletters' || pageType === 'terms' || pageType === 'privacy' || pageType === 'sitemap' || pageType === 'giveassured' || pageType === 'careers' ? "".concat(GiNavToggler_config.cdnUrl, "/static/images/giveindia-logo-v2.jpg") : "".concat(GiNavToggler_config.cdnUrl, "/static/images/give-monthly-giving-2x.jpg"),
                    height: pageType === 'homepage' || pageType === 'aboutus' || pageType === 'contactus' || pageType === 'newsletters' || pageType === 'terms' || pageType === 'privacy' || pageType === 'sitemap' || pageType === 'giveassured' || pageType === 'careers' ? '35' : '30',
                    alt: ""
                }) : null
            ]
        })
    });
};
/* harmony default export */ var header_GiNavToggler = (GiNavToggler);

// EXTERNAL MODULE: ./components/workplace/common/partnerLogo.js
var partnerLogo = __webpack_require__(80161);
;// CONCATENATED MODULE: ./components/workplace/WGHeader/WGNavToggler.js





var WGNavToggler_handleNavLinkClick = function handleNavLinkClick() {
    window.location.href = '/';
};
var WGNavToggler = function(param) {
    var logo = param.logo, isOpen = param.isOpen;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("div", {
        onClick: WGNavToggler_handleNavLinkClick,
        className: "jsx-c726e1ced895268" + " " + "d-flex",
        children: [
            isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-c726e1ced895268",
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partnerLogo/* default */.Z, {
                    w: "100%",
                    className: "wg-login-partner-logo"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-c726e1ced895268",
                children: [
                    logo === 'color' || !logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(partnerLogo/* default */.Z, {
                        w: "100%",
                        className: "wg-login-partner-logo"
                    }) : null,
                    logo === 'white' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(partnerLogo/* default */.Z, {
                        w: "100%",
                        className: "wg-login-partner-logo"
                    }) : null,
                    logo === 'black' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(partnerLogo/* default */.Z, {
                        w: "100%",
                        className: "wg-login-partner-logo"
                    }) : null
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "c726e1ced895268",
                children: ".wg-login-partner-logo{max-width:100px}"
            })
        ]
    }));
};
/* harmony default export */ var WGHeader_WGNavToggler = ((0,react_contextual_es/* subscribe */.Ld)()(WGNavToggler));

;// CONCATENATED MODULE: ./components/chrome/elements/icons/burgerNav.js


function burgerNav_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function burgerNav_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            burgerNav_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var BurgerNav = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: burgerNav_objectSpread({}, props.style, {
            width: '48px',
            padding: '3px'
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: props.color || '#000',
                stroke: props.stroke || '#000',
                strokeWidth: props.strokeWidth || 0.1,
                d: "M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/chrome/elements/icons/cancel.js


function cancel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cancel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cancel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/* harmony default export */ function cancel(props) {
    return(/*#__PURE__*/ _jsx("div", {
        style: cancel_objectSpread({}, props.style),
        className: props.className,
        children: /*#__PURE__*/ _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: props.width || props.size,
            height: props.height || props.size,
            viewBox: "0 0 58 58",
            style: {
                enableBackground: "new 0 0 58 58"
            },
            children: [
                /*#__PURE__*/ _jsx("rect", {
                    style: {
                        fill: "none",
                        width: "58",
                        height: "58"
                    }
                }),
                /*#__PURE__*/ _jsx("line", {
                    style: {
                        fill: "none",
                        stroke: props.stroke || "#424A60",
                        strokeWidth: 5,
                        strokeMiterlimit: 10
                    },
                    x1: "44",
                    y1: "14",
                    x2: "14.302",
                    y2: "43.698"
                }),
                /*#__PURE__*/ _jsx("line", {
                    style: {
                        fill: "none",
                        stroke: props.stroke || "#424A60",
                        strokeWidth: 5,
                        strokeMiterlimit: 10
                    },
                    x1: "44",
                    y1: "43.698",
                    x2: "14.302",
                    y2: "14"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/chrome/layout/newHeader/burgerNavMenu.js




var BurgerNavMenu = function(props) {
    var strokeColor = '#000';
    var color = '#000';
    if (props.backgroundColor && props.backgroundColor === 'transparent') {
        strokeColor = '#fff';
        color = '#fff';
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: 'd-flex align-self-center',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerNav, {
            stroke: strokeColor,
            color: color
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faChevronDown.js
var faChevronDown = __webpack_require__(41145);
// EXTERNAL MODULE: ./components/chrome/elements/icons/fontAwesomeSVGIcon.js
var fontAwesomeSVGIcon = __webpack_require__(44106);
;// CONCATENATED MODULE: ./components/chrome/layout/newHeader/header.js



// import './_header.scss';



















var header_config = (0,config["default"])().publicRuntimeConfig;
var LoggedInUserAvatar = /*#__PURE__*/ react.memo(function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
        nav: true,
        inNavbar: true,
        isOpen: props.profileDropdownOpen,
        toggle: props.profileDropdownToggle,
        onMouseEnter: props.profileDropdownToggle,
        onMouseLeave: props.profileDropdownToggle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle/* default */.Z, {
                nav: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginRight: '8px'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            style: {
                                margin: 0,
                                width: 36,
                                height: 36
                            },
                            src: props.user.profilePic
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fontAwesomeSVGIcon/* default */.Z, {
                            icon: faChevronDown/* faChevronDown */.pt,
                            className: "ml-auto",
                            width: "12px",
                            style: {
                                right: "-6px"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenu/* default */.Z, {
                style: {
                    top: '95%'
                },
                right: true,
                className: "profile-dropdown",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                        href: "/user/profile",
                        target: "_blank",
                        children: "Monthly Giving Profile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                        href: "".concat(header_config.fundraisersPlatformUrl, "me"),
                        target: "_blank",
                        children: "Fundraiser profile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignoutButton, {
                        session: props.session,
                        _csrf: props._csrf
                    })
                ]
            })
        ]
    }));
});
var WPGLoggedInUserAvatar = /*#__PURE__*/ react.memo(function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
        nav: true,
        inNavbar: true,
        isOpen: props.profileDropdownOpen,
        toggle: props.profileDropdownToggle,
        onMouseEnter: props.profileDropdownToggle,
        onMouseLeave: props.profileDropdownToggle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle/* default */.Z, {
                nav: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginRight: '8px'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            style: {
                                margin: 0,
                                width: 36,
                                height: 36
                            },
                            src: props.user.profilePic
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fontAwesomeSVGIcon/* default */.Z, {
                            icon: faChevronDown/* faChevronDown */.pt,
                            className: "ml-auto",
                            width: "12px",
                            style: {
                                right: "-6px"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenu/* default */.Z, {
                style: {
                    top: '95%'
                },
                right: true,
                className: "profile-dropdown",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                        href: "/user/profile",
                        target: "_blank",
                        children: "Profile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignoutButton, {
                        session: props.session,
                        _csrf: props._csrf
                    })
                ]
            })
        ]
    }));
});
var LoginButton = /*#__PURE__*/ react.memo(function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        style: {
            backgroundColor: '#ff5050',
            fontSize: '13.5px',
            bordeRadius: '5px',
            fontWeight: 600,
            boxShadow: 'none',
            padding: '10px 15px',
            border: 0,
            color: 'white',
            marginRight: '15px'
        },
        onClick: props.handleLoginClick,
        children: "Log In"
    }));
});
var Header = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var logo = props.logo, toggleLogInModal = props.toggleLogInModal, toggleSignUpModal = props.toggleSignUpModal, backgroundColor = props.backgroundColor, session = props.session, canonicalUrl = props.canonicalUrl, stickyTop = props.stickyTop, fixedTop = props.fixedTop, navHeight = props.navHeight, color = props.color, width = props.width, hideSearch = props.hideSearch, tenantConfig = props.tenantConfig, subdomain = props.subdomain, loginBackgroundColor = props.loginBackgroundColor, hideOldPlatformLink = props.hideOldPlatformLink, hideMainMenu = props.hideMainMenu, _csrf = props._csrf, hideLogin = props.hideLogin, store = props.store, pageType = props.pageType, hideHeaderOnScroll = props.hideHeaderOnScroll, headerShadow = props.headerShadow;
    console.log(pageType, subdomain);
    var missionLinks = (ref2 = tenantConfig === null || tenantConfig === void 0 ? void 0 : (ref = tenantConfig.header) === null || ref === void 0 ? void 0 : (ref1 = ref.menuLinks) === null || ref1 === void 0 ? void 0 : ref1.find(function(menuLink) {
        return menuLink.heading === 'Missions';
    })) === null || ref2 === void 0 ? void 0 : ref2.missions;
    var causeLinks = tenantConfig === null || tenantConfig === void 0 ? void 0 : (ref3 = tenantConfig.header) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.menuLinks) === null || ref4 === void 0 ? void 0 : ref4.filter(function(menuLink) {
        return menuLink.heading !== 'Missions';
    });
    var ref5 = (0,react.useState)(false), showExpandedHeader = ref5[0], setShowExpandedHeader = ref5[1];
    var ref6 = (0,react.useState)(false), searchPopoverOpen = ref6[0], setSearchPopoverOpen = ref6[1];
    var ref7 = (0,react.useState)(false), profileDropdownOpen = ref7[0], setProfileDropdownOpen = ref7[1];
    var ref8 = (0,react.useState)(false), missionDropdownOpen = ref8[0], setMissionDropdownOpen = ref8[1];
    var ref9 = (0,react.useState)(false), causeDropdownOpen = ref9[0], setCauseDropdownOpen = ref9[1];
    var ref10 = (0,react.useState)(false), donateDropdownOpen = ref10[0], setDonateDropdownOpen = ref10[1];
    var ref11 = (0,react.useState)(false), getinvolvedDropdownOpen = ref11[0], setGetinvolvedDropdownOpen = ref11[1];
    var ref12 = (0,react.useState)(null), user = ref12[0], setUser = ref12[1];
    var ref13 = (0,react.useState)(false), hasUpdateSeen = ref13[0], setHasUpdateSeen = ref13[1];
    var ref14 = (0,react.useState)(headerShadow || true), headerShadowVal = ref14[0], setHeaderShadowVal = ref14[1];
    (0,react.useEffect)(function() {
        if (session === null || session === void 0 ? void 0 : session.user) {
            setUser(session.user);
        }
    }, [
        session
    ]);
    (0,react.useEffect)(function() {
        if (window) {
            if (cookies/* default.read */.Z.read('updates_seen')) {
                setHasUpdateSeen(true);
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if (showExpandedHeader) {
            document.body.classList.add('expanded-header-open');
        } else {
            document.body.classList.remove('expanded-header-open');
        }
    }, [
        showExpandedHeader
    ]);
    (0,react.useEffect)(function() {
        if (headerShadowVal !== headerShadow && headerShadow !== undefined) {
            setHeaderShadowVal(headerShadow);
        }
    }, [
        props === null || props === void 0 ? void 0 : props.headerShadow
    ]);
    var updateClicked = function(e) {
        e.preventDefault();
        cookies/* default.save */.Z.save('updates_seen', true);
        window.location.href = "/user/reports";
    };
    var handleCloseExpandedHeader = function() {
        return setShowExpandedHeader(false);
    };
    var handleShowExpandedHeader = function() {
        setShowExpandedHeader(true);
        setSearchPopoverOpen(false);
        setProfileDropdownOpen(false);
        setCauseDropdownOpen(false);
        setMissionDropdownOpen(false);
    };
    var toggleSearchPopover = function() {
        setSearchPopoverOpen(!searchPopoverOpen);
        setProfileDropdownOpen(false);
        setCauseDropdownOpen(false);
        setMissionDropdownOpen(false);
    };
    var profileDropdownToggle = function() {
        setProfileDropdownOpen(!profileDropdownOpen);
        setSearchPopoverOpen(false);
        setCauseDropdownOpen(false);
        setMissionDropdownOpen(false);
    };
    var causeDropdownToggle = function() {
        setCauseDropdownOpen(!causeDropdownOpen);
        setProfileDropdownOpen(false);
        setSearchPopoverOpen(false);
        setMissionDropdownOpen(false);
    };
    var missionDropdownToggle = function() {
        setMissionDropdownOpen(!missionDropdownOpen);
        setProfileDropdownOpen(false);
        setSearchPopoverOpen(false);
        setCauseDropdownOpen(false);
    };
    var donateDropdownToggle = function(input) {
        setDonateDropdownOpen(input);
        setGetinvolvedDropdownOpen(false);
    };
    var getinvolvedDropdownToggle = function(input) {
        setGetinvolvedDropdownOpen(input);
        setDonateDropdownOpen(false);
    };
    var handleLoginClick = function() {
        setSearchPopoverOpen(false);
        toggleLogInModal();
    };
    var trackMissionAndCauseClick = function(e, eventName, eventInfo) {
        try {
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEventSync(eventName, eventInfo, {
                    amplitude: true
                });
            }
        } catch (e1) {
            console.log('Error tracking mission and cause click', e1);
        }
        return true;
    };
    var hamburgerCircleStyle = showExpandedHeader ? {
        borderColor: '#444444'
    } : {
        borderColor: color === 'white' ? color : '#444444'
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                light: true,
                className: "homescreen-header ".concat(hideHeaderOnScroll ? '' : 'hs-sticky', " ").concat(!showExpandedHeader && headerShadowVal ? 'hs-shadow' : '', " ").concat(showExpandedHeader ? 'expanded-header-background-color' : ''),
                style: {
                    backgroundColor: backgroundColor,
                    minHeight: '64px'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarToggler/* default */.Z, {
                        className: "borderless-toggler",
                        style: {
                            cursor: 'pointer'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(selectByPlatform/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(header_GiNavToggler, {
                                    name: 'www',
                                    logo: showExpandedHeader ? 'black' : logo,
                                    pageType: pageType
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WGHeader_WGNavToggler, {
                                    name: 'wg',
                                    logo: showExpandedHeader ? 'black' : logo
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                        className: "ml-auto ".concat(!(pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers' || pageType === 'user-dashboard' || pageType === 'checkout' || pageType === 'monthly-homepage')),
                        children: [
                            !showExpandedHeader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                     false && /*#__PURE__*/ 0,
                                    !hideLogin && (missionLinks === null || missionLinks === void 0 ? void 0 : missionLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                        nav: true,
                                        inNavbar: true,
                                        isOpen: missionDropdownOpen,
                                        toggle: missionDropdownToggle,
                                        onMouseEnter: missionDropdownToggle,
                                        onMouseLeave: missionDropdownToggle,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle/* default */.Z, {
                                                nav: true,
                                                className: "nav-links-md",
                                                style: {
                                                    color: color ? color : '#444444',
                                                    textTransform: 'capitalize'
                                                },
                                                children: [
                                                    "Missions",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fontAwesomeSVGIcon/* default */.Z, {
                                                        icon: faChevronDown/* faChevronDown */.pt,
                                                        className: "ml-auto",
                                                        width: "7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu/* default */.Z, {
                                                right: true,
                                                children: missionLinks === null || missionLinks === void 0 ? void 0 : missionLinks.map(function(mission1, index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: mission1.src,
                                                        onClick: function(e, mission) {
                                                            trackMissionAndCauseClick(e, 'Navbar Mission', {
                                                                mission: mission
                                                            });
                                                        },
                                                        children: mission1.heading
                                                    }, "missions-link-".concat(index)));
                                                })
                                            })
                                        ]
                                    }),
                                    !hideLogin && subdomain === 'www' && (causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                        nav: true,
                                        inNavbar: true,
                                        isOpen: causeDropdownOpen,
                                        toggle: causeDropdownToggle,
                                        onMouseEnter: causeDropdownToggle,
                                        onMouseLeave: causeDropdownToggle,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle/* default */.Z, {
                                                nav: true,
                                                className: "nav-links-md",
                                                style: {
                                                    color: color ? color : '#444444',
                                                    textTransform: 'capitalize'
                                                },
                                                children: [
                                                    "Causes",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fontAwesomeSVGIcon/* default */.Z, {
                                                        icon: faChevronDown/* faChevronDown */.pt,
                                                        className: "ml-auto",
                                                        width: "7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu/* default */.Z, {
                                                children: causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.map(function(cause1, index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: cause1.src,
                                                        className: cause1.className,
                                                        onClick: function(e, cause) {
                                                            trackMissionAndCauseClick(e, 'Navbar Cause', {
                                                                cause: cause
                                                            });
                                                        },
                                                        children: cause1.heading
                                                    }, "causes-link-".concat(index)));
                                                })
                                            })
                                        ]
                                    }),
                                    (pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers') && subdomain === 'www' && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                        className: "nav-links-md nav-link",
                                        style: {
                                            color: color ? color : '#444444',
                                            textTransform: 'capitalize'
                                        },
                                        href: "".concat(header_config.fundraisersPlatformUrl, "start-a-campaign"),
                                        target: "_blank",
                                        children: "start a fundraiser"
                                    }),
                                    (pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers') && subdomain === 'www' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                        nav: true,
                                        inNavbar: true,
                                        isOpen: donateDropdownOpen,
                                        // toggle={donateDropdownToggle}
                                        onMouseEnter: function() {
                                            return donateDropdownToggle(true);
                                        },
                                        onMouseLeave: function() {
                                            return donateDropdownToggle(false);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle/* default */.Z, {
                                                nav: true,
                                                className: "nav-links-md",
                                                style: {
                                                    color: color ? color : '#444444',
                                                    textTransform: 'capitalize'
                                                },
                                                children: [
                                                    "Donate",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fontAwesomeSVGIcon/* default */.Z, {
                                                        icon: faChevronDown/* faChevronDown */.pt,
                                                        className: "ml-auto",
                                                        width: "7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenu/* default */.Z, {
                                                style: {
                                                    top: '95%'
                                                },
                                                right: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: "/monthly",
                                                        target: "_blank",
                                                        children: "Monthly Giving"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: "".concat(header_config.fundraisersPlatformUrl),
                                                        target: "_blank",
                                                        children: "Fundraisers"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: "https://covid.giveindia.org",
                                                        target: "_blank",
                                                        children: "Covid Missions"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers') && subdomain === 'www' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                        nav: true,
                                        inNavbar: true,
                                        isOpen: getinvolvedDropdownOpen,
                                        // toggle={getinvolvedDropdownToggle}
                                        onMouseEnter: function() {
                                            return getinvolvedDropdownToggle(true);
                                        },
                                        onMouseLeave: function() {
                                            return getinvolvedDropdownToggle(false);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle/* default */.Z, {
                                                nav: true,
                                                className: "nav-links-md",
                                                style: {
                                                    color: color ? color : '#444444',
                                                    textTransform: 'capitalize'
                                                },
                                                children: [
                                                    "Get involved",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fontAwesomeSVGIcon/* default */.Z, {
                                                        icon: faChevronDown/* faChevronDown */.pt,
                                                        className: "ml-auto",
                                                        width: "7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenu/* default */.Z, {
                                                style: {
                                                    top: '95%'
                                                },
                                                left: "true",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: "https://workplace.giveindia.org/",
                                                        target: "_blank",
                                                        children: "Corporate Partnerships"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: "https://partnerships.giveindia.org/",
                                                        target: "_blank",
                                                        children: "Brand & Retail Partnerships"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: "".concat(header_config.fundraisersPlatformUrl, "start-a-campaign"),
                                                        target: "_blank",
                                                        children: "Fundraise"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                        href: "https://institutionalgiving.giveindia.org/",
                                                        target: "_blank",
                                                        children: "Institutional Giving"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers') && subdomain === 'www' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "nav-links-md",
                                        style: {
                                            paddingTop: '0'
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavLink/* default */.Z, {
                                            style: {
                                                color: color ? color : '#444444',
                                                textTransform: 'capitalize',
                                                display: 'flex',
                                                alignItems: 'center'
                                            },
                                            href: "/search",
                                            target: "_blank",
                                            children: [
                                                "Search",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(searchIcon, {
                                                    stroke: "#000",
                                                    strokeWidth: "5px",
                                                    color: logo === 'white' ? '#fff' : '#000',
                                                    style: {
                                                        width: '13.5px',
                                                        marginRight: '5px',
                                                        marginTop: '5px',
                                                        marginLeft: '5px'
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    (pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers') && subdomain === 'www' && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                        href: '/aboutus',
                                        className: "nav-links-md",
                                        children: "About us"
                                    }),
                                    subdomain !== 'www' && // user?.hasDonated &&
                                    // user?.hasBeneficiaryAssigned &&
                                    user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            (causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                                nav: true,
                                                inNavbar: true,
                                                isOpen: causeDropdownOpen,
                                                toggle: causeDropdownToggle,
                                                onMouseEnter: causeDropdownToggle,
                                                onMouseLeave: causeDropdownToggle,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle/* default */.Z, {
                                                        nav: true,
                                                        className: "nav-links-md",
                                                        style: {
                                                            color: color ? color : '#444444',
                                                            textTransform: 'capitalize'
                                                        },
                                                        children: [
                                                            "Causes",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fontAwesomeSVGIcon/* default */.Z, {
                                                                icon: faChevronDown/* faChevronDown */.pt,
                                                                className: "ml-auto",
                                                                width: "7"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu/* default */.Z, {
                                                        children: causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.map(function(cause2, index) {
                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                                                                href: cause2.src,
                                                                className: cause2.className,
                                                                onClick: function(e, cause) {
                                                                    trackMissionAndCauseClick(e, 'Navbar Cause', {
                                                                        cause: cause
                                                                    });
                                                                },
                                                                children: cause2.heading
                                                            }, "causes-link-".concat(index)));
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                                className: "nav-links-md",
                                                id: "search-popover",
                                                onMouseEnter: toggleSearchPopover,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(searchIcon, {
                                                    stroke: "#000",
                                                    strokeWidth: "5px",
                                                    color: color ? color : '#444444',
                                                    style: {
                                                        width: '12px'
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onMouseLeave: toggleSearchPopover,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.Z, {
                                                    className: "search-section",
                                                    placement: "bottom",
                                                    trigger: "click",
                                                    target: "search-popover",
                                                    isOpen: searchPopoverOpen,
                                                    toggle: toggleSearchPopover,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverBody/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newQuickSearch, {
                                                            placeholder: "Search"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    subdomain !== 'www' ? null : hideSearch ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            !hideLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                                className: "nav-links-md",
                                                id: "search-popover",
                                                onMouseEnter: toggleSearchPopover,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(searchIcon, {
                                                    stroke: "#000",
                                                    strokeWidth: "5px",
                                                    color: color ? color : '#444444',
                                                    style: {
                                                        width: '12px'
                                                    }
                                                })
                                            }),
                                            !hideLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onMouseLeave: toggleSearchPopover,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.Z, {
                                                    className: "search-section",
                                                    placement: "bottom",
                                                    trigger: "click",
                                                    target: "search-popover",
                                                    isOpen: searchPopoverOpen,
                                                    toggle: toggleSearchPopover,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverBody/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newQuickSearch, {
                                                            placeholder: "Search"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !hideLogin && subdomain === 'www' && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                className: "navbar-toggler-icon-container",
                                onClick: showExpandedHeader ? handleCloseExpandedHeader : handleShowExpandedHeader,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "navbar-toggler-icon-circle",
                                    style: hamburgerCircleStyle,
                                    children: !showExpandedHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerNavMenu, {
                                        backgroundColor: backgroundColor
                                    }) : // <span className="navbar-dark-toggler-icon toggler-icon"></span>
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(header_config.cdnUrl, "/static/icons/close.svg"),
                                        alt: "close",
                                        style: {
                                            height: '1rem'
                                        },
                                        className: "close-icon toggler-icon"
                                    })
                                })
                            }),
                            (pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers' || pageType === 'user-dashboard' || pageType === 'homepage' || pageType === 'missions' || pageType === 'search' || pageType === 'program' || pageType === 'category' || pageType === 'contactus' || pageType === 'thankyou' || pageType === 'monthly-homepage') && subdomain === 'www' && !session.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                                handleLoginClick: handleLoginClick
                            }),
                            (pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers' || pageType === 'user-dashboard' || pageType === 'homepage' || pageType === 'missions' || pageType === 'search' || pageType === 'program' || pageType === 'category' || pageType === 'contactus' || pageType === 'thankyou' || pageType === 'monthly-homepage') && subdomain === 'www' && session.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggedInUserAvatar, {
                                profileDropdownOpen: profileDropdownOpen,
                                profileDropdownToggle: profileDropdownToggle,
                                session: session,
                                user: session.user,
                                _csrf: _csrf
                            }),
                            subdomain !== 'www' && session.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(WPGLoggedInUserAvatar, {
                                profileDropdownOpen: profileDropdownOpen,
                                profileDropdownToggle: profileDropdownToggle,
                                session: session,
                                user: session.user,
                                _csrf: _csrf
                            }),
                            hideLogin && subdomain === 'www' && /*#__PURE__*/ (0,jsx_runtime.jsx)((react_responsive_default()), {
                                maxWidth: 992,
                                device: {
                                    width: width
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                    className: "navbar-toggler-icon-container",
                                    onClick: showExpandedHeader ? handleCloseExpandedHeader : handleShowExpandedHeader,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "navbar-toggler-icon-circle",
                                        style: hamburgerCircleStyle,
                                        children: !showExpandedHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerNavMenu, {
                                            backgroundColor: backgroundColor
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(header_config.cdnUrl, "/static/icons/close.svg"),
                                            alt: "close",
                                            style: {
                                                height: '1rem'
                                            },
                                            className: "close-icon toggler-icon"
                                        })
                                    })
                                })
                            }),
                            subdomain !== 'www' && user && /*#__PURE__*/ (0,jsx_runtime.jsx)((react_responsive_default()), {
                                maxWidth: 992,
                                device: {
                                    width: width
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                    className: "navbar-toggler-icon-container",
                                    onClick: showExpandedHeader ? handleCloseExpandedHeader : handleShowExpandedHeader,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "navbar-toggler-icon-circle",
                                        style: hamburgerCircleStyle,
                                        children: !showExpandedHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerNavMenu, {
                                            backgroundColor: backgroundColor
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(header_config.cdnUrl, "/static/icons/close.svg"),
                                            alt: "close",
                                            style: {
                                                height: '1rem'
                                            },
                                            className: "close-icon toggler-icon"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            showExpandedHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                className: "homescreen-header-expanded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: !hideHeaderOnScroll ? 'expanded-header-margin' : '',
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 11,
                            xs: 12,
                            className: "part-2 order-md-2 ".concat(!hideHeaderOnScroll ? 'expanded-header-padding' : ''),
                            children: subdomain === 'www' ? !hideLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    !hideSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 12,
                                        className: "search-section-mob",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newQuickSearch, {
                                            placeholder: "Search",
                                            hideRecommendations: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: true,
                                        xs: 6,
                                        className: "sub-links order-md-2",
                                        children: (missionLinks === null || missionLinks === void 0 ? void 0 : missionLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "heading",
                                                    children: "Missions"
                                                }),
                                                missionLinks === null || missionLinks === void 0 ? void 0 : missionLinks.map(function(mission2, index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: mission2.src,
                                                            onClick: function(e, mission) {
                                                                trackMissionAndCauseClick(e, 'Extended Navbar Mission', {
                                                                    mission: mission
                                                                });
                                                            },
                                                            children: mission2.heading
                                                        })
                                                    }, "missions-link-".concat(index)));
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: true,
                                        xs: 6,
                                        className: "main-links order-md-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: '/aboutus',
                                                        children: "About Us"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(header_config.fundraisersPlatformUrl),
                                                        target: "_blank",
                                                        children: "GiveIndia Fundraisers"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://workplace.giveindia.org/",
                                                        target: "_blank",
                                                        children: "Workplace Giving"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: '/certified-indian-ngos',
                                                        children: "Partner NGOs"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: '/all-ngos',
                                                        children: "NGOs in India"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: 'https://gi.giveindia.org/',
                                                        target: "_blank",
                                                        children: "Previous Platform"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: '/giveassured',
                                                        children: "GiveAssured"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: true,
                                        xs: 6,
                                        className: "sub-links order-md-3",
                                        children: (causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "heading",
                                                    children: "Causes"
                                                }),
                                                causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.map(function(cause3, index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: cause3.src,
                                                            onClick: function(e, cause) {
                                                                trackMissionAndCauseClick(e, 'Extended Navbar Cause', {
                                                                    cause: cause
                                                                });
                                                            },
                                                            children: cause3.heading
                                                        })
                                                    }, "causes-link-".concat(index)));
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: true,
                                        xs: 6,
                                        className: "main-links order-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: 'https://www.giveindia.org/blog/post-page/',
                                                        target: "_blank",
                                                        children: "Blogs"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: '/careers',
                                                        children: "Careers"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: 'https://support.giveindia.org/support/home',
                                                        target: "_blank",
                                                        children: "Help"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: '/contactus',
                                                        children: "Contact Us"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    md: true,
                                    xs: 12,
                                    className: "main-links order-md-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(header_config.fundraisersPlatformUrl, "start-a-campaign"),
                                                    target: "_blank",
                                                    children: "Start a Fundraiser"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ham-heading",
                                                        children: "Donate"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "/monthly",
                                                                    target: "_blank",
                                                                    children: "Monthly Giving"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "".concat(header_config.fundraisersPlatformUrl),
                                                                    target: "_blank",
                                                                    children: "Fundraisers"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "https://covid.giveindia.org",
                                                                    target: "_blank",
                                                                    children: "Covid Missions"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ham-heading",
                                                        children: "Get Involved"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "https://workplace.giveindia.org/",
                                                                    target: "_blank",
                                                                    children: "Corporate Partnerships"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "https://partnerships.giveindia.org/",
                                                                    target: "_blank",
                                                                    children: "Brand & Retail Partnerships"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "".concat(header_config.fundraisersPlatformUrl, "start-a-campaign"),
                                                                    target: "_blank",
                                                                    children: "Fundraise"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "https://institutionalgiving.giveindia.org/",
                                                                    target: "_blank",
                                                                    children: "Institutional Giving"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavLink/* default */.Z, {
                                                    className: "nav-links-md",
                                                    style: {
                                                        color: color ? color : '#444444',
                                                        textTransform: 'capitalize',
                                                        display: 'flex',
                                                        justifyContent: 'left',
                                                        alignItems: 'center',
                                                        padding: '0'
                                                    },
                                                    href: "/search",
                                                    target: "_blank",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(searchIcon, {
                                                            stroke: "#000",
                                                            strokeWidth: "5px",
                                                            color: logo === 'white' ? '#fff' : '#000',
                                                            style: {
                                                                width: '13.5px',
                                                                marginRight: '5px',
                                                                marginTop: '5px'
                                                            }
                                                        }),
                                                        "Search"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/aboutus",
                                                    target: "_blank",
                                                    children: "About Us"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 12,
                                        className: "search-section-mob",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newQuickSearch, {
                                            placeholder: "Search",
                                            hideRecommendations: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 12,
                                        className: "sub-links order-md-1",
                                        children: (causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "heading",
                                                    children: "Causes"
                                                }),
                                                causeLinks === null || causeLinks === void 0 ? void 0 : causeLinks.map(function(cause4, index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: cause4.src,
                                                            onClick: function(e, cause) {
                                                                trackMissionAndCauseClick(e, 'Extended Navbar Cause', {
                                                                    cause: cause
                                                                });
                                                            },
                                                            children: cause4.heading
                                                        })
                                                    }, "causes-link-".concat(index)));
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 1,
                            xs: 12,
                            className: "part-1 order-md-1 ".concat(!hideHeaderOnScroll ? 'expanded-header-padding' : ''),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "header-social-icons",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            rel: "noopener noreferrer",
                                            href: "https://www.facebook.com/GiveIndia/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebookIcon/* default */.Z, {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                                size: 20,
                                                color: "".concat((colors_default()).giveMidGrey)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            rel: "noopener noreferrer",
                                            href: "https://twitter.com/giveindia/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitterIcon/* default */.Z, {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                                size: 20,
                                                color: "".concat((colors_default()).giveMidGrey)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            rel: "noopener noreferrer",
                                            href: "https://www.instagram.com/give_india/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagramIcon/* default */.Z, {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                                size: 20,
                                                color: "".concat((colors_default()).giveMidGrey)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            rel: "noopener noreferrer",
                                            href: "https://www.linkedin.com/company/giveindia/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedinIcon/* default */.Z, {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                                size: 20,
                                                color: "".concat((colors_default()).giveMidGrey)
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./components/chrome/layout/newHeader/index.js


// EXTERNAL MODULE: ./components/auth/signInModal.js
var signInModal = __webpack_require__(84012);
// EXTERNAL MODULE: ./components/chrome/elements/selectComponent/index.js
var selectComponent = __webpack_require__(67130);
// EXTERNAL MODULE: ./util/selectPlatform.js
var selectPlatform = __webpack_require__(41395);
;// CONCATENATED MODULE: ./components/workplace/WGFooter/index.js








function WGFooter_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function WGFooter_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function WGFooter_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function WGFooter_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) WGFooter_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) WGFooter_defineProperties(Constructor, staticProps);
    return Constructor;
}
function WGFooter_getPrototypeOf(o) {
    WGFooter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return WGFooter_getPrototypeOf(o);
}
function WGFooter_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) WGFooter_setPrototypeOf(subClass, superClass);
}
function WGFooter_possibleConstructorReturn(self, call) {
    if (call && (WGFooter_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return WGFooter_assertThisInitialized(self);
}
function WGFooter_setPrototypeOf(o, p) {
    WGFooter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return WGFooter_setPrototypeOf(o, p);
}
var WGFooter_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function WGFooter_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function WGFooter_createSuper(Derived) {
    var hasNativeReflectConstruct = WGFooter_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = WGFooter_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = WGFooter_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return WGFooter_possibleConstructorReturn(this, result);
    };
}
var WGFooter_config = (0,config["default"])().publicRuntimeConfig;
var WGFooter_getLocalStore = function(name) {
    try {
        return JSON.parse(localStorage.getItem(name));
    } catch (err) {
        return null;
    }
};
var WGFooter_Footer = /*#__PURE__*/ function(_Component) {
    "use strict";
    WGFooter_inherits(Footer, _Component);
    var _super = WGFooter_createSuper(Footer);
    function Footer(props) {
        WGFooter_classCallCheck(this, Footer);
        var _this;
        _this = _super.call(this, props);
        var session = props.session;
        var currentCurrency = 'INR';
        var localStoreCurrency = WGFooter_getLocalStore('currentCurrency');
        if (localStoreCurrency) {
            currentCurrency = localStoreCurrency;
        } else if (session && session.currentCurrency) {
            currentCurrency = session.currentCurrency;
        } else if (session && session.country) {
            currentCurrency = session.country;
        }
        if (currentCurrency === 'INR' || currentCurrency === 'IN') {
            _this.state = {
                currency: 'INR',
                toggle: false
            };
        } else {
            _this.state = {
                currency: 'USD',
                toggle: true
            };
        }
        return _this;
    }
    WGFooter_createClass(Footer, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "footer",
                    id: "footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "footer-top d-flex",
                            style: {
                                paddingTop: '2rem',
                                paddingBottom: '2rem'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: "12",
                                md: "12",
                                lg: "12",
                                sm: "12",
                                className: "d-flex justify-content-center align-self-center footer-height-for-mobile ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "footer-column flex-wg-footer",
                                    children: [
                                        this.props.subdomain === "hdfc" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            height: "40px",
                                            alt: 'GiveIndia Logo',
                                            src: "".concat(WGFooter_config.cdnUrl, "/static/images/giveindia-logo-v2-small.jpg")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            height: "40px",
                                            alt: 'GiveIndia Logo',
                                            src: "".concat(WGFooter_config.cdnUrl, "/static/images/wg/workplace-giving-color.jpg")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-wg-footer footer-column-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/aboutus",
                                                        className: "footer-menu-link-2",
                                                        target: "_blank",
                                                        children: " About Us "
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(this.props.tenantConfig.faq ? '/company-faqs' : '/faqs'),
                                                        className: "footer-menu-link-2",
                                                        target: "_blank",
                                                        children: " FAQs "
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/contactus",
                                                        className: "footer-menu-link-2",
                                                        target: "_blank",
                                                        children: " Contact Us "
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                                            children: "\n                                .flex-wg-footer {\n                                    display: flex;\n                                    justify-content: space-between;\n                                    padding: 0 20px;\n                                    align-items: center;\n                                } \n\n                                .footer-column-2 {\n                                    width: 40%\n                                }\n\n                                .footer-menu-link-2 {\n                                    color: #708099\n                                }\n\n                                .footer-menu-link-2:hover {\n                                    text-decoration: none;\n                                    color: #708099\n                                }\n                                @media(max-width: 768px) {\n                                    .footer-column-2 {\n                                        width: 100%\n                                    }\n                                    .flex-wg-footer {\n                                        justify-content: center; \n                                        padding: 10px 0 0 0;\n                                    }\n                                    .footer-menu-link-2 {\n                                        padding: 10px;\n                                    }\n                                }\n                                "
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "footer-bottom",
                            style: {
                                justifyContent: 'space-between'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        marginTop: '10px',
                                        textAlign: 'center'
                                    },
                                    className: "jsx-b7b8296c14ff3d4d" + " " + "footer-bottom-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "jsx-b7b8296c14ff3d4d",
                                            children: "\xa9 GiveIndia \xa0 \xa0 \xa0 \xa0 Donations through this platform are tax exempted under 80G & 501(c)(3)"
                                        }),
                                        (0,jsx_runtime.jsx)((style_default()), {
                                            id: "b7b8296c14ff3d4d",
                                            children: ".footer-exempted-span.jsx-b7b8296c14ff3d4d{display:inline-block;\npadding-bottom:0;\npadding-top:10px;\nwidth:100%}"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "footer-bottom-right",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "no-hover-a",
                                                href: "/terms",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Terms"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "no-hover-a",
                                                href: "/privacy",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Privacy Policy"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                rel: "noopener noreferrer",
                                                href: "https://www.facebook.com/GiveIndia/",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebookIcon/* default */.Z, {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },
                                                    size: 20,
                                                    color: "".concat((colors_default()).giveMidGrey)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                rel: "noopener noreferrer",
                                                href: "https://twitter.com/giveindia/",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitterIcon/* default */.Z, {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },
                                                    size: 20,
                                                    color: "".concat((colors_default()).giveMidGrey)
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return Footer;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/reactstrap/es/NavbarBrand.js
var NavbarBrand = __webpack_require__(36992);
// EXTERNAL MODULE: ./components/chrome/elements/icons/giveIndia.js
var giveIndia = __webpack_require__(95015);
;// CONCATENATED MODULE: ./components/chrome/elements/icons/trustedNGOsIcon.js



var TrustedNgosIcon = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 316.38 191.22",
        style: {
            width: props.size,
            height: props.size
        },
        className: style_default().dynamic([
            [
                "d34762758cb20958",
                [
                    props.theme.primaryColor
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ]),
                /*#__PURE__*/ children: "trusted NGOs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Layer_1-2",
                    "data-name": "Layer 1",
                    className: style_default().dynamic([
                        [
                            "d34762758cb20958",
                            [
                                props.theme.primaryColor
                            ]
                        ]
                    ]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M242,122.54l-70.46-46.2c-6.19,2.26-11.9,4.45-17.69,6.43-9.22,3.15-18.83,3.82-28.47,3.73A13.37,13.37,0,0,1,116.29,83c-2.76-2.57-3.14-4.12-.94-7.35a49.32,49.32,0,0,1,6-7.28c5.35-5.31,11.66-9.36,18.24-13,7.57-4.17,15.16-8.31,22.8-12.34,13-6.84,26.62-9,41-5.48,7.08,1.75,14.09,3.76,21.18,5.46,4.17,1,8.43,1.62,13.49,2.57l32.17,54.73c-9.87,6-18.57,13.06-24.54,23.6,1.41,1.7,2.8,3.52,4.33,5.21,6.86,7.56,2.45,18.89-7.06,21-3.22.71-6.5,1.44-9.83.2a7.09,7.09,0,0,0-2.37,0c-3.28,12.65-9,16.62-20.35,14.07-1.12,5.07-2.83,10-7.85,12.52s-10,1.92-15-.38c-.45,1.47-.83,2.91-1.33,4.3-1.64,4.49-4.62,7.69-9.28,9a27.31,27.31,0,0,1-12.79.83c-4.53-.87-9.15-1.25-14-1.89.73-3.85,3.86-5.58,5.44-8.55,4,.8,7.84,1.63,11.71,2.33,2.95.54,5.86.79,8.82-.35s3.73-3.51,4-6.26-1-4.31-3.3-5.56c-6.43-3.46-12.78-7.07-19.12-10.6a5.08,5.08,0,0,1-.56-1.49c0-4,2.1-5.5,5.66-3.73s6.69,3.7,10,5.54c6.71,3.66,13.38,7.43,20.19,10.9,3.66,1.87,7.28.35,9.16-3.31,1.8-3.51.78-7.09-2.89-9.43-2.38-1.52-4.91-2.8-7.38-4.17l-20.52-11.35a22.83,22.83,0,0,1-2.16-1.24c-1.82-1.29-2.29-2.62-1.57-4.19,1-2.1,2.68-2.81,5-1.94a21.2,21.2,0,0,1,2.65,1.39q15.05,8.34,30.1,16.69c2.47,1.37,4.91,2.84,7.48,4a7.13,7.13,0,0,0,6.76-12.56c-4.56-2.74-9.28-5.2-13.92-7.79l-18.28-10.2a19.4,19.4,0,0,1-2.56-1.55c-1.71-1.34-2-2.78-1.07-4.32a3.58,3.58,0,0,1,4.7-1.64,22,22,0,0,1,2.13,1.29c11.89,6.65,23.76,13.36,35.72,19.88a37.68,37.68,0,0,0,8.37,3.13,10.72,10.72,0,0,0,9.08-1.47c2.27-1.55,2.77-3,1.48-5.45a30,30,0,0,0-3.28-5C239.49,128.76,239.15,125.83,242,122.54Z",
                            className: style_default().dynamic([
                                [
                                    "d34762758cb20958",
                                    [
                                        props.theme.primaryColor
                                    ]
                                ]
                            ]) + " " + "cls-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M235.5,30.46,269.92,6.15c2.29.42,3.16,2.09,4.07,3.65q9.08,15.49,18.1,31l22.14,37.88a29,29,0,0,1,1.48,2.6c1.13,2.49.93,3.46-1.34,5.07Q299.72,96.7,285,107c-3.22,2.23-4.11,1.89-6.18-1.66q-20.45-35.07-40.9-70.14C237.18,33.9,236.57,32.55,235.5,30.46Z",
                            className: style_default().dynamic([
                                [
                                    "d34762758cb20958",
                                    [
                                        props.theme.primaryColor
                                    ]
                                ]
                            ]) + " " + "cls-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M90.37,34.22C111.2,40.12,131.6,45,153,44.59c-3.39,2-6.58,4.58-10.22,5.83-3,1-6.56.9-9.79.52-15.68-1.82-30.92-5.7-46.22-10.66C86.2,41.16,85.51,42,85,43Q74.83,60.17,64.74,77.37q-5.9,10.09-11.69,20.26c-.81,1.42-1.42,3-2.2,4.61,1.84,1.47,3.43,2.9,5.18,4.1a75.48,75.48,0,0,1,16,14.85c3.06,3.78,3.06,4.11.25,8.17A19.64,19.64,0,0,1,71,130.87c-3.68-4.09-7-8.36-11-12s-8.26-6.6-12.64-10c-1.11,1.39-1.87,2.42-2.71,3.38-2.28,2.6-4.17,2.92-6.94,1C28.85,107,20,100.84,11.14,94.66c-2.86-2-5.76-3.94-8.6-6S-.68,85.5,1,82.43c3.72-6.68,7.62-13.26,11.46-19.87q12.76-22,25.54-44,4.51-7.76,9.13-15.46c2.21-3.68,3.62-4,7.17-1.54Q71.56,13.5,88.75,25.5c.41.28.81.58,1.19.9,2.45,2,2.56,2.49,1.38,5.5C91.08,32.5,90.83,33.09,90.37,34.22ZM52.07,8.62,8.14,84l31.81,22,44-75.26Z",
                            className: style_default().dynamic([
                                [
                                    "d34762758cb20958",
                                    [
                                        props.theme.primaryColor
                                    ]
                                ]
                            ]) + " " + "cls-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M128.29,131.29a25.8,25.8,0,0,1-1.85,3.95c-5.56,8.66-11.21,17.27-16.83,25.89-1.36,2.09-2.79,4.14-4,6.3-1.83,3.19-4.68,4-8.06,3.73-4.26-.39-10.45-4.64-10.83-9.54a9.75,9.75,0,0,1,1.73-6.49c4.92-7.5,9.78-15,14.66-22.57,2.08-3.21,4.07-6.47,6.23-9.62,2.38-3.48,5.39-4.5,9.54-3.44C124.46,120.92,128.37,125.35,128.29,131.29Z",
                            className: style_default().dynamic([
                                [
                                    "d34762758cb20958",
                                    [
                                        props.theme.primaryColor
                                    ]
                                ]
                            ]) + " " + "cls-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M120.51,177.32a9.86,9.86,0,0,1-9.15-4.72c-1.7-2.67-2.08-5.59-.22-8.44,5.62-8.63,11.14-17.31,16.91-25.84,2.9-4.3,9.49-4.2,13.52-.1,3.35,3.41,3.78,7,1.13,11.21-5.13,8.14-10.41,16.19-15.51,24.35C125.5,176.48,123.31,177.75,120.51,177.32Z",
                            className: style_default().dynamic([
                                [
                                    "d34762758cb20958",
                                    [
                                        props.theme.primaryColor
                                    ]
                                ]
                            ]) + " " + "cls-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M81.26,154.29c-6.34-.28-10.2-3.28-12.7-7.85a6.8,6.8,0,0,1,.41-7.11c4-6.1,7.87-12.28,11.91-18.36,2-3,5.19-3.93,9.29-2.7a13.48,13.48,0,0,1,7.33,4.89c3.23,4.47,3.14,7,.45,10.83-3.71,5.3-7.06,10.84-10.6,16.25C85.74,152.73,83.75,154.65,81.26,154.29Z",
                            className: style_default().dynamic([
                                [
                                    "d34762758cb20958",
                                    [
                                        props.theme.primaryColor
                                    ]
                                ]
                            ]) + " " + "cls-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M140.61,191.22c-7,0-11.94-4.59-11.58-10.14a10.88,10.88,0,0,1,1.56-4.61c1.77-3,3.76-5.89,5.75-8.76,2.33-3.37,5-4.21,9.11-3,5.38,1.57,8.42,5.59,8,10.53a2.72,2.72,0,0,1-.13,1c-2.65,5-5.1,10.1-9.46,13.85A7.79,7.79,0,0,1,140.61,191.22Z",
                            className: style_default().dynamic([
                                [
                                    "d34762758cb20958",
                                    [
                                        props.theme.primaryColor
                                    ]
                                ]
                            ]) + " " + "cls-1"
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "d34762758cb20958",
                dynamic: [
                    props.theme.primaryColor
                ],
                children: ".cls-1{fill:".concat(props.theme.primaryColor, "}")
            })
        ]
    }));
};
/* harmony default export */ var trustedNGOsIcon = (TrustedNgosIcon);

;// CONCATENATED MODULE: ./components/chrome/elements/icons/securePaymentsIcon.js



var SecurePaymentsIcon = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 614.27 547.42",
        style: {
            width: props.size,
            height: props.size
        },
        className: style_default().dynamic([
            [
                "d34762758cb20958",
                [
                    props.theme.primaryColor
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ]),
                /*#__PURE__*/ children: "secure payment"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Layer_1-2",
                    "data-name": "Layer 1",
                    className: style_default().dynamic([
                        [
                            "d34762758cb20958",
                            [
                                props.theme.primaryColor
                            ]
                        ]
                    ]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "OWX2mR",
                        className: style_default().dynamic([
                            [
                                "d34762758cb20958",
                                [
                                    props.theme.primaryColor
                                ]
                            ]
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M21.07,328.95l27.74,17.39c0,10.45,0,21.1,0,31.74,0,3.41.18,6.82.19,10.23q0,34.25,0,68.5c0,8.23.16,16.47,0,24.7-.35,14.6,10.22,30,25.18,35.56a41,41,0,0,0,14.61,2.43q39.22-.15,78.44-.09,48.71,0,97.42,0,66.45,0,132.91,0,61.44,0,122.87.06c9.5,0,19-.13,28.49,0,9.65.09,18-3.64,24.93-9.76a38.32,38.32,0,0,0,13.1-29.56q.06-59.49,0-119,0-18,0-36c0-1.31,0-2.62,0-4.47-20.73-.34-41.16-.06-61.58-.16s-40.66,0-61,0q-30.75,0-61.49,0-30.5,0-61,0H218.49c22.36-21.79,37-47.08,43.85-77H586.51a34.58,34.58,0,0,0,.42-3.62c0-5.67.19-11.34,0-17-.69-18.8-12.5-34-31.67-38.27a33,33,0,0,0-6-.39c-1.66-.06-3.33,0-5,0-16.64-.21-33.27-.59-49.91-.59-16.14,0-32.27.52-48.41.55-12,0-24-1-35.9-.44-15.82.75-31.61.31-47.42.42-11.8.08-23.63-1-35.4-.43-15.48.73-30.95.24-46.42.43-4.77.06-9.55-.52-14.48-.81-1.9-8.77-1-17.54-1.32-26.25,1.77-1.32,3.67-.72,5.42-.73q63-.06,126,0,76,0,152,0a63.24,63.24,0,0,1,37.32,11.78c14.27,10.11,23.9,23.82,27.32,41.28a76.47,76.47,0,0,1,1.16,14.35c.1,28.66.05,57.32.05,86q0,66,0,132,0,20.49,0,41a61.19,61.19,0,0,1-8.78,31.16,65.85,65.85,0,0,1-22.58,23.4c-8.42,5.22-17.49,8.64-27.45,9.34-5.29.37-10.6.8-15.9.8q-75.73.09-151.47,0-41.17,0-82.33,0c-29.94,0-59.88-.14-89.83-.13-42.16,0-84.31.17-126.47.1-20.26,0-37.58-7.31-51.32-22.37A64.25,64.25,0,0,1,22,490.83a88.25,88.25,0,0,1-1-13.38Q21,415.22,21.06,353C21.07,345,21.07,337,21.07,328.95Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M.27,157.65l229.51-.88a19.23,19.23,0,0,1,.32,2.44c0,18.65,0,37.31.11,56,0,11.91-2.44,23.39-6.4,34.49a115.4,115.4,0,0,1-68.1,68.94,109.3,109.3,0,0,1-36.35,7.11c-15.26.38-30-1.59-44.34-7.08a117,117,0,0,1-38.6-24,115.57,115.57,0,0,1-28-40.76A108.28,108.28,0,0,1,.9,223.64C-.84,206.86.57,190.06.08,173.28c-.12-4,0-8,0-12C.09,160.18.19,159.07.27,157.65Zm130.88,58.11h0c0-4.78.14-9.56-.07-14.33a12.91,12.91,0,0,0-1.52-5.65c-4.61-8.08-10.76-9.57-18.56-8.07-6.16,1.19-11.48,7.1-11.71,14.94-.34,11.47-.29,23,0,34.42.17,7.37,5.21,14.58,13.81,15.65,9.23,1.14,17.87-5.42,18.06-14.64C131.27,230.64,131.14,223.2,131.14,215.76Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M56.15,123.26H20.43c-.09-1.51-.26-2.8-.22-4.09.19-6.25.45-12.5.66-18.74a19.26,19.26,0,0,0,0-4.49c-.93-4.49-.07-8.93.44-13.3A91.65,91.65,0,0,1,37,41.29,93.9,93.9,0,0,1,72.63,10.11,88,88,0,0,1,103.8.61c18.3-1.82,36.2.26,52.8,8.76,26.57,13.6,44,34.79,51.2,63.88A74.16,74.16,0,0,1,210.19,93c-.21,8.83,0,17.67,0,26.5,0,1.14,0,2.28,0,4-12,.12-23.73,0-35.87.07,0-5.44,0-10.39,0-15.35,0-1.95.25-3.89.23-5.84,0-4.56.12-9.09-.35-13.7a58.34,58.34,0,0,0-11.34-28.78,56.53,56.53,0,0,0-36.06-23C107.68,33.18,90.65,38,76,50.93a56.39,56.39,0,0,0-18.31,31.2,67.21,67.21,0,0,0-1.51,12.29C56,103.9,56.15,113.38,56.15,123.26Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M200.75,480.64H143.28q-22,0-44,0c-2.73,0-5.3-.16-7.21-2.55s-2.75-5.27-1.62-8.35a7.67,7.67,0,0,1,7.09-5.37c1.16-.09,2.33,0,3.5,0h428c3.5,0,7-.06,10.49,0a8.49,8.49,0,0,1,8.49,8.06,8,8,0,0,1-8.27,8.16c-7.83.11-15.66,0-23.49,0H200.75Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M200.73,364.2H516.27c7.83,0,15.65,0,23.48,0,3.44,0,6.05,1.31,7.39,4.77a8.24,8.24,0,0,1-7.06,11.49c-1.82.14-3.66,0-5.49,0l-432.48,0c-1.5,0-3,.09-4.5,0a8.07,8.07,0,0,1-7.6-8.29,7.71,7.71,0,0,1,7.8-7.93c8.16-.13,16.32-.05,24.48-.05h78.44Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M201.06,414.31H536.55a44.68,44.68,0,0,1,4.49.06,8.32,8.32,0,0,1,7,7.87,8.45,8.45,0,0,1-7.19,8.24c-1.16.11-2.33,0-3.49,0-37.46,0-311-.05-348.47-.06q-45,0-89.9,0c-6.67,0-11-6.29-8.09-11.76a7.71,7.71,0,0,1,7.24-4.4c4.66,0,9.32,0,14,0Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            })
                        ]
                    })
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "d34762758cb20958",
                dynamic: [
                    props.theme.primaryColor
                ],
                children: ".cls-1{fill:".concat(props.theme.primaryColor, "}")
            })
        ]
    }));
};
/* harmony default export */ var securePaymentsIcon = (SecurePaymentsIcon);

;// CONCATENATED MODULE: ./components/chrome/elements/icons/longTermImpactIcon.js



var child = /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "cls-1",
                d: "M397.08,389.93c-6.5-1.08-12.87-2.53-19.2-4.19-5.38-1.41-10.63-3.34-15.93-5.06-12.27-4-23.57-10.09-34.65-16.46-7.51-4.32-14.46-9.7-21.27-15.09a196.47,196.47,0,0,1-35.66-37.48A192.39,192.39,0,0,1,256.9,290a174.5,174.5,0,0,1-9.76-20.58A198.35,198.35,0,0,1,239,244.53a179.4,179.4,0,0,1-4.5-25.23c-.83-8.39-2-16.72-1.7-25.18.09-3-.24-6,.12-9,.78-6.52,2.14-13,2.78-19.5s2.3-12.91,3.9-19.26a151.37,151.37,0,0,1,8.35-24.63c3.54-7.93,7.59-15.64,11.63-23.33,1.76-3.34,4.16-6.33,6.1-9.57a132.77,132.77,0,0,1,20.1-25.61q7-7,14.09-13.93c5.83-5.65,12.49-10.29,19.09-15a115.78,115.78,0,0,1,12.44-7.64c7.47-4,14.18-9.57,22.88-11a7.54,7.54,0,0,0,1.78-.85A50.37,50.37,0,0,1,362.23,12c4.34-1.37,9.08-1.56,12.8-4.64A2,2,0,0,1,376,7c9.72-1.6,19.21-4.32,29.09-5.22C412.59,1.14,420.11.11,427.69,0a67.29,67.29,0,0,1,13.84.76c4.31.84,8.84.08,13.29,1.11,6.71,1.55,13.59,2.35,20.31,3.82a167.91,167.91,0,0,1,23,7.19c12.09,4.55,23.82,9.75,34.44,17.24,3.35,2.36,6.75,4.65,10.26,6.77,7.37,4.45,13.71,10.21,20,15.93A140.42,140.42,0,0,1,580.81,72c4.18,5.51,8.78,10.75,12.44,16.59,5.66,9,11.29,18.15,15.21,28.15,3,7.64,6.29,15.19,8.8,23,2.15,6.69,3.44,13.66,5,20.55a146.46,146.46,0,0,1,3.14,26.43,206.8,206.8,0,0,1-.59,26.83c-.63,6.58-1.45,13.13-2.56,19.59a156.37,156.37,0,0,1-7.42,27c-2.31,6.33-4.64,12.68-7.37,18.83a151.58,151.58,0,0,1-8.32,16.25c-3.19,5.34-6.84,10.42-10.53,15.44-4.47,6.08-8.68,12.46-13.9,17.84a233.78,233.78,0,0,1-32.19,28.18c-7.8,5.55-16.13,10.06-24.38,14.72-5,2.83-10.52,4.74-15.79,7.08a153.43,153.43,0,0,1-29.57,9.34,174.57,174.57,0,0,1-19,3.24c-5.9.62-11.71,1.91-17.7,1.66-2.33-.1-4.67,0-7,0C418.3,393.07,407.71,391.7,397.08,389.93Zm43.58-157.39a23.41,23.41,0,0,0,3.25.44q39.47,0,78.94,0c4.33,0,4.34-.3,5-4.3A187.09,187.09,0,0,0,530,206c.16-4.07,1.19-8.25.67-12.3-.86-6.6-.28-13.28-1.09-19.8-1-8.28-3.17-16.42-4.82-24.63a2.88,2.88,0,0,0-3.16-2.54H443.14c-.65,0-1.29.11-2.49.22ZM335.59,158.72c-1.87,9.38-3.36,18.83-3.21,28.48.05,3.29-1.14,6.72-.56,9.86,1.18,6.39.32,12.84,1.39,19.28.89,5.32,1.09,10.79,2.66,16.34a32.65,32.65,0,0,0,3.25.31q37.24,0,74.47,0a18.84,18.84,0,0,0,2.5,0c1.76-.24,2.94-1.45,2.43-3-1.47-4.59-.67-9.25-.7-13.86-.12-19.83-.07-39.65,0-59.48a48.29,48.29,0,0,1,.7-6.35c.28-2.06-.46-3.17-2.51-3.46a14.27,14.27,0,0,0-2,0H341c-.65,0-1.29.11-1.77.15C336.17,150.42,336.38,154.79,335.59,158.72ZM441.22,256c-.11.11-.23.22-.34.35s-.26.26-.26.4q-.09,42.49-.16,85c0,1,0,2,.12,3,0,.29.31.56.64,1.11,10.37-4.27,20.43-9.1,29.07-16.55,4.2-3.62,9.07-6.6,12.79-10.64,5.88-6.39,12-12.68,16.69-20,2.49-3.86,5-7.74,7.35-11.66a149.42,149.42,0,0,0,11.6-24.42c.76-2,1.37-4,2.06-6C516.93,255.47,451.7,255.08,441.22,256Zm-97.68,5.49c1.72,3.31,2.57,7.06,4.2,10.42,2.36,4.87,5,9.61,7.7,14.31,1.8,3.15,4.83,5.92,5.59,9.25.94,4.08,3.49,6.87,6.08,9.11a90.35,90.35,0,0,1,8.72,9.32,122.67,122.67,0,0,0,18.25,16.39c5.56,4.24,11.52,8.22,18.2,10.7,1.85.69,3.31,3.19,6.22,1.26-1-14-.79-28.26-.7-42.53s-.49-28.82.45-43.77c-1.64-.07-3.4-.2-5.17-.2-19.14,0-38.28,0-57.42,0-4.1,0-8.21-.27-12.91-.44A9.73,9.73,0,0,0,343.54,261.45Zm-30.08-28.62c.07-1.57.46-3.08.13-4.42-1.3-5.33-1.22-10.82-2-16.16-1.33-8.8-.86-17.56-.66-26.3.16-7.2,1.56-14.37,2.47-21.54.72-5.66,1.55-11.31,2.33-16.92-3.91-.91-41.67-1.1-47.5-.32-3.46,9.78-5.29,20-6.52,30.2a121.87,121.87,0,0,0-.91,24.25c.84,10.39.69,21,4.32,31.21Zm279.64-.08c2-1.91,2.13-5,2.43-7.54,1.18-10.17,2.65-20.32,2.24-30.64-.3-7.43-.83-14.79-1.78-22.19a175.15,175.15,0,0,0-5.45-25c-3.64-.84-36.55-1.08-43.86-.27,0,1.52-.38,3.22.06,4.67,2.58,8.42,2.87,17.16,4,25.79,1.39,10.79.6,21.57.62,32.35,0,4.73-1.23,9.46-1.69,14.2-.25,2.63,0,5.31,0,8.58ZM298.88,255.69c-6.16,0-12.32.06-18.48,0-2.28,0-4.56-.51-6.84-.69-.41,0-.86.37-1.81.81.83,2.43,1.49,4.92,2.51,7.25a170.5,170.5,0,0,0,19.33,33.75,182,182,0,0,0,23.64,25.68c10.13,9.29,21.5,16.71,33.42,23.24a175,175,0,0,0,17,7.67c7,2.92,14.51,4.2,21.48,7.13,1.23.52,2.8.25,4.63-.58a43,43,0,0,0-4.59-3.82c-6.49-4.07-12.23-9-18-14s-10.67-10.66-15.66-16.27a125,125,0,0,1-12.24-16.63,241.88,241.88,0,0,1-13-23.51c-2.78-5.73-4.79-11.84-7-17.82-1.43-3.83-2.66-7.75-4.17-12.2ZM514.21,124.8c.79-2.43.36-4.41-.77-6.89-3.76-8.28-8.62-15.89-13.59-23.41A120.1,120.1,0,0,0,482.3,73.83C471.6,63.65,459.91,55,446.09,49.37c-1.63-.66-2.92-2.28-5-1.32-.85,3.5-1.16,68-.31,76.75ZM350.87,125H413.3a23.3,23.3,0,0,0,2.5,0c2.29-.25,3-1.35,2.62-3.75a35.41,35.41,0,0,1-.6-5.37q-.07-28.47,0-56.94c0-2.45.56-4.89.78-7.34a16.84,16.84,0,0,0-.16-2.53c-3.86-.67-6.55,1.54-9.36,2.94-10.06,5-18.86,12-27.21,19.36-4.5,4-8.25,8.84-12.27,13.37-7.16,8.07-12.29,17.52-17.75,26.72-2.31,3.89-3.76,8.29-6,13.29C348.29,124.85,349.58,125,350.87,125Zm225,130.69c-9.5.05-19,0-28.49,0-3.95,0-3.72.14-5,3.85-3.08,9-6,18-10.3,26.63-3.22,6.49-6.47,12.92-10.21,19.14a208.28,208.28,0,0,1-11.76,17.36c-6.45,8.64-14.4,15.87-22,23.38-4.15,4.1-9.41,7.06-14.12,10.6a18.39,18.39,0,0,0-2.27,2.89c3.64-.9,6.33-1.31,8.83-2.23,6.43-2.37,13-4.58,19.12-7.56,7.52-3.65,15.14-7.15,22-12.09,4.95-3.56,10-6.9,14.68-10.88,6.36-5.43,12.3-11.27,18.1-17.29,10.47-10.87,18.14-23.7,25.43-36.73,2-3.63,4.53-7.29,5-11.72.1-.89,1.13-1.65,1.38-2.57a15.51,15.51,0,0,0,.23-3.24C582.44,255.41,579.16,255.65,575.88,255.67ZM322.35,124.78c1.91-4.59,3.68-9.35,5.84-13.92,3.44-7.26,6.9-14.54,10.82-21.56a158.87,158.87,0,0,1,17.22-24.4,182.83,182.83,0,0,1,27.62-26.24c2.13-1.68,4.55-3,7.24-4.72-2.13-1.59-3.73-1.22-5.49-.62-4.67,1.58-9.46,2.82-14.05,4.59-5.52,2.12-11,4.47-16.28,7A151.83,151.83,0,0,0,341.5,52.5c-4.17,2.58-8.13,5.5-12.07,8.43s-7.9,5.85-11.54,9.13A164.43,164.43,0,0,0,303.66,84a210.85,210.85,0,0,0-15.06,19.47c-3.87,5.67-6.91,11.91-10.26,17.93a17.8,17.8,0,0,0-1,3.37Zm258.11,0c0-1.23.38-2.51-.06-3.35-3.82-7.27-7.62-14.56-12.64-21.13-3.74-4.89-7.13-10.07-11.09-14.76a137.52,137.52,0,0,0-11.5-11.76,230.42,230.42,0,0,0-19.09-15.45c-8.71-6.53-18.32-11.48-28-16.09-7.64-3.63-16-5.68-24.09-8.4-.24-.08-.59.17-1.34.41.46.81.69,1.83,1.32,2.22a133.51,133.51,0,0,1,23.22,18.93,142.78,142.78,0,0,1,18.15,21.92c3.9,5.9,7.77,11.84,11.24,18,2.89,5.12,5.27,10.54,7.69,15.91,2,4.33,3.65,8.78,5.62,13.55Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "cls-1",
                d: "M146.29,569a22.87,22.87,0,0,0,3.49-1.11,115.27,115.27,0,0,1,19.82-8.48c4.4-1.31,8.69-3,13.22-3.89,7.6-1.57,15.08-2.4,23-1.13a262.76,262.76,0,0,1,26.41,5.88c8.72,2.35,17.31,5,25.83,8,7.58,2.66,15.31,4.88,22.94,7.4,8.1,2.68,16.15,5.52,24.24,8.24,9,3,18,6.1,27.08,9,6.71,2.16,13.4,4.5,20.26,6.06,8.78,2,17.41,5.16,26.61,4.69a70.91,70.91,0,0,0,18.38-3.3c5.46-1.77,11.06-3.09,16.57-4.73,4.39-1.31,8.74-2.75,13.08-4.21q6.76-2.28,13.47-4.72c6.62-2.43,13.21-4.94,19.82-7.4,3.36-1.25,6.77-2.37,10.09-3.73,8.94-3.67,17.84-7.43,26.75-11.16,5.43-2.27,10.91-4.45,16.28-6.87,4.93-2.22,9.76-4.65,14.57-7.12,5.25-2.69,10.48-5.4,15.61-8.31,5.45-3.09,10.79-6.39,16.13-9.67a15.73,15.73,0,0,0,2.41-2.5h-4.88c-6.83,0-13.67.1-20.5,0-14.1-.26-28.19-.76-42.29-.93s-28,0-42-.11a35.67,35.67,0,0,1-7.73-1.42c-2.38-.57-4.7-1.37-7-2.05-.71-1.4-.41-2.33,1.15-2.53a30.92,30.92,0,0,1,3.49-.07c5.33,0,10.67,0,16-.15,9.77-.27,19.54-.78,29.31-1s19.72.6,29.47-.27c8-.7,15.9-.24,23.81-.89,20.79-1.7,41.59-.5,62.39-.79,10.33-.15,20.65,0,31-.08,2.44,0,4.87-.85,7.31-.89,4.85-.07,7-3.24,8.2-7.14,1.93-6.5,3.42-13.24,2.36-20a29.75,29.75,0,0,0-14.73-21.78c-8.5-5.1-17.73-7.47-27.38-9.08a75,75,0,0,0-11.82-.81c-10.83-.09-21.69.44-32.49-.15-30.59-1.67-61.22-.15-91.79-1.23-10.8-.38-21.63.09-32.37-.78-9-.73-17.95-1.55-26.84-3.54-12.92-2.89-25.2-7.48-37.31-12.57-4.07-1.71-7.68-4.5-11.54-6.71-3-1.7-6-3.3-9.06-4.89-7.13-3.73-14.13-7.76-21.45-11.06-11.8-5.33-23.53-11-36.21-14.07-7.33-1.79-14.66-3.75-22.11-4.84-6.68-1-13.52-1-20.29-1.22a162.63,162.63,0,0,0-17,.1c-7.2.53-14.44.89-21.56,2.32-3.7.74-7.49,1-11.22,1.65-3.56.59-7.11,1.27-10.63,2.07Q186.28,407.44,176,410c-5.89,1.46-11.71,3.19-17.63,4.53s-11.9,2.36-17.86,3.47c-4,.75-8.1,1.41-12.15,2.11-5.49.94-11,1.94-16.48,2.81-3.55.56-7.14.93-11.08,1.44a16.69,16.69,0,0,0,.36,3.28c2.67,8.46,5.45,16.89,8.1,25.35,2.35,7.51,4.51,15.09,6.88,22.59,3.45,11,7.05,21.88,10.51,32.85,1.83,5.79,3.38,11.68,5.23,17.46,2.66,8.28,5.52,16.5,8.23,24.76,1.54,4.68,2.93,9.41,4.44,14.1C145,566.12,145.65,567.44,146.29,569Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "cls-1",
                d: "M132.82,585.06c-.38-1.58-.7-3.18-1.16-4.74-3.08-10.56-6.09-21.15-9.32-31.67-3.42-11.14-7.17-22.18-10.6-33.32-4.53-14.74-8.87-29.55-13.34-44.3-2.24-7.38-4.64-14.71-6.92-22.08-2.43-7.83-4.75-15.7-7.24-23.52a47.57,47.57,0,0,0-3.07-7.27c-2.57-5-7.68-7-13.27-5.29q-13.7,4.09-27.4,8.2c-9.9,3-19.83,5.85-29.67,9-4.82,1.56-9,4.31-10.46,9.58A10.35,10.35,0,0,0,.32,445c1.13,4.11,3.07,8,3.94,12.16,1.79,8.57,5.29,16.58,7.49,25,1,3.8,2.15,7.56,3.28,11.32,1.56,5.19,3.13,10.38,4.76,15.55,1.78,5.63,3.7,11.22,5.45,16.86,2.23,7.2,4.33,14.44,6.52,21.65,1.72,5.65,3.53,11.27,5.24,16.92,1.33,4.38,2.54,8.8,3.84,13.19.56,1.89,1.27,3.74,1.87,5.62,1.7,5.32,3.56,10.6,5,16A38,38,0,0,0,55,613.08c2.28,2.86,6,3.23,9.53,2.17,5.35-1.59,10.66-3.29,16-4.9,9.74-2.94,19.51-5.78,29.24-8.78,4.86-1.5,9.67-3.18,14.46-4.9C129.17,594.89,133,590,132.82,585.06Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "cls-1",
                d: "M578.39,449.69c8.49,0,17,.19,25.46-.06,6.21-.18,12.17,1.12,18.15,2.28a80,80,0,0,1,20,6.8,40.21,40.21,0,0,1,10.64,7c2.51,2.45,3,2.67,5.89.95,6.33-3.74,12.59-7.61,18.87-11.44,2.8-1.7,5.58-3.43,8.38-5.13,14-8.51,28.09-17,42.07-25.57a110.85,110.85,0,0,0,11.26-7.9c6.41-5.14,9.42-12.33,10.08-20.2a27.36,27.36,0,0,0-3.38-14.74c-3.17-6.1-8.77-9.57-14.27-13.09a15.57,15.57,0,0,0-5.13-1.59c-8.47-1.8-16.1.46-23.31,4.87-6.29,3.85-12.34,8.09-19,11.41-3.51,1.75-6.61,4.34-9.94,6.48-6.61,4.24-13.16,8.56-19.89,12.6-7.86,4.71-16,9-23.82,13.74-9,5.43-17.76,11.18-26.66,16.74-8.21,5.12-16.46,10.18-24.69,15.26-.42.26-.81.56-1.21.84Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "cls-1",
                d: "M674.27,373.29c-8.83-11.48-20.1-12.57-31.88-8-3.91,1.5-7.25,4.45-10.88,6.69q-13.81,8.51-27.65,17l-11.74,7.22q-13.41,8.27-26.81,16.55c-7.12,4.41-14.2,8.89-21.34,13.26-7.65,4.69-15.36,9.3-23,13.94l-14.83,8.93c6.67-.57,12.29.55,17.89-.9a13.08,13.08,0,0,1,6,0c6.43,1.46,12.92.55,19.37.68,3.08.06,5.32-2.42,7.81-3.9,7.34-4.36,14.41-9.17,21.74-13.55,9.58-5.72,19.08-11.56,28.59-17.39,4.9-3,9.82-6,14.73-8.95q15.09-9.21,30.16-18.46c3.93-2.42,7.74-5,11.69-7.39C667.38,377,670.84,375.19,674.27,373.29Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "cls-1",
                d: "M598.88,378.67c-3.52-2.95-7.48-4-11.47-4.61a20.5,20.5,0,0,0-13.83,2.9c-7.14,4.29-14.24,8.66-21.45,12.84-6.25,3.62-12.07,7.91-18.48,11.29-5.06,2.67-9.75,6-14.61,9.1-5.68,3.56-11.34,7.13-17,10.63-6.28,3.86-12.57,7.7-18.83,11.59-6.79,4.22-13.63,8.41-20.52,12.5a26.59,26.59,0,0,0-3.75,2.17c4.55,1,9.11.6,13.64.68s8.95,0,13.67,0Z"
            })
        ]
    })
});
var LongTermImpactIcon = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 749.28 615.8",
        style: {
            width: props.size,
            height: props.size
        },
        className: style_default().dynamic([
            [
                "d34762758cb20958",
                [
                    props.theme.primaryColor
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ]),
                children: "long term impact"
            }),
            child,
            (0,jsx_runtime.jsx)((style_default()), {
                id: "d34762758cb20958",
                dynamic: [
                    props.theme.primaryColor
                ],
                children: ".cls-1{fill:".concat(props.theme.primaryColor, "}")
            })
        ]
    }));
};
/* harmony default export */ var longTermImpactIcon = (LongTermImpactIcon);

;// CONCATENATED MODULE: ./components/chrome/elements/icons/regularReportsIcon.js



var RegularReportIcon = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 633.53 685.18",
        style: {
            width: props.size,
            height: props.size
        },
        className: style_default().dynamic([
            [
                "d34762758cb20958",
                [
                    props.theme.primaryColor
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ]),
                /*#__PURE__*/ children: "regular report"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                className: style_default().dynamic([
                    [
                        "d34762758cb20958",
                        [
                            props.theme.primaryColor
                        ]
                    ]
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Layer_1-2",
                    "data-name": "Layer 1",
                    className: style_default().dynamic([
                        [
                            "d34762758cb20958",
                            [
                                props.theme.primaryColor
                            ]
                        ]
                    ]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "_80JmaY",
                        "data-name": "80JmaY",
                        className: style_default().dynamic([
                            [
                                "d34762758cb20958",
                                [
                                    props.theme.primaryColor
                                ]
                            ]
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M20.22,685.18c-.87-1.56-2.39-.92-3.58-.89-6.88.2-11.19-3.87-14.2-9.19-1.55-2.74-2.07-6.32-2.2-9.55-.31-7.65-.13-15.33-.07-23,0-1.29.52-2.58.57-3.87.08-2.11,0-4.23-.06-6.34,0-2.43-.1-4.87,0-7.3,0-1.8.87-3.8.33-5.35-1.15-3.29-.81-6.56-.81-9.84q0-124,0-248c0-2.12.5-4.23.67-6.35a11.09,11.09,0,0,0-.26-2.35,25.75,25.75,0,0,1-.42-2.91c-.07-2.86,1.73-5.69.15-8.59C2.09,338.77,0,336,0,333.07c.24-23.5.13-47,.13-70.49q0-69,0-138c0-4.9,1-9.44,4.16-13.4,3.87-4.9,9.17-6.93,15.06-7,17-.2,34-.1,51-.05,4.21,0,5.44,1.81,4.46,6.09-.14.63-.54,1.33-.39,1.87,1.88,6.87.54,13.87.79,20.8.08,2.36-.8,4.76-1.3,7.44H36.29c0,2.14,0,3.93,0,5.72q0,79.24,0,158.49c0,2.1-.58,4.2-.78,6.31a7.49,7.49,0,0,0,.17,2.91,15.83,15.83,0,0,1,0,9.71c-.19.61-.49,1.45-.23,1.89,1.58,2.66.83,5.54.83,8.3q.07,154.49,0,309v5.72c1.38.22,2.47.47,3.57.54,1.33.09,2.67,0,4,0q130,0,260,0c7.59,0,15.18-.33,22.78-.42,2,0,4,.38,6,.41a22.92,22.92,0,0,0,3.59-.52c0-5.19,0-10.14,0-15.1,0-3.33-.1-6.67,0-10a32.92,32.92,0,0,1,1-4.91c11.8-.08,23.2,0,34.76,0,.18,1.91.37,3,.37,4.17q0,21.75,0,43.5c0,8.92-5.33,14.61-12.12,17.68-1.42.64-3.26.33-4.88.6s-3.65-.81-5.09.9h-69q-1.5-1.94-3,0Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M256.22.09c50,0,100,.06,150-.09a17.31,17.31,0,0,1,13.17,5.5c10.91,11,21.92,21.87,32.88,32.8q17,16.92,33.88,33.86,16.07,16.07,32.13,32.15,11.07,11,22.21,22c.35.35.9.58,1.11,1,1.88,3.77,4.41,6.87,8.45,8.47,2.38,5.17,8.1,8.92,6.38,15.88-.54,2.19,0,4.64,0,7q0,91.73-.08,183.47c0,4.41,1.06,6.94,5.18,9.46,11.12,6.79,20.89,15.44,29.79,25a162.71,162.71,0,0,1,14.18,17.52,148.19,148.19,0,0,1,16.19,29.18,195.92,195.92,0,0,1,8.94,28.57c3.88,16.27,3,32.66,2.55,49-.17,6.5-1.87,13-3.45,19.39a174.93,174.93,0,0,1-6.61,21.66c-2.7,6.86-6.26,13.41-9.71,20a141.15,141.15,0,0,1-20.5,28.62,145.79,145.79,0,0,1-33.44,27.68,170.82,170.82,0,0,1-21.72,11.5,181.61,181.61,0,0,1-23.8,7.93c-16.24,4.25-32.68,5.28-49.29,4.5-5.58-.26-11.13-1.45-16.66-2.46-5.33-1-10.63-2.12-15.87-3.46a83,83,0,0,1-10.78-3.56c-11.24-4.59-22.3-9.54-32.16-16.78-1.42-1-3-1.91-4.42-2.92-5.25-3.67-5.24-3.68-11.84-3.68-89.32,0-178.63-.12-267.95.16-10.33,0-18.3-8.86-18.56-17.92-.17-5.94-.9-12,.66-17.88a8.36,8.36,0,0,0,0-3.48c-1.24-6.93-1-13.84-.23-20.81.33-3.07-.52-6.25-.53-9.38q-.06-58.74,0-117.48,0-200.46,0-400.92c0-4.08.47-8,2.37-11.57C91.81,3.91,96.52.1,103.75.11q76.24,0,152.47,0Zm131.9,36.18c-1.33-.07-2.14-.16-2.94-.16l-262,.13c-.13,0-.28.14-.4.24a5.77,5.77,0,0,0-.44.49q0,267.52,0,535.28c0,.13.16.27.26.4s.22.25.39.43H343.42c.14,0,.29-.17.4-.28a4.82,4.82,0,0,0,.39-.61A173.63,173.63,0,0,1,332,550.09a176.79,176.79,0,0,1-9-24.47,133.56,133.56,0,0,1-4.75-25.27c-.77-8.69-1-17.43-1.49-26.32H295.61c-16,0-32,0-48,0-5.17,0-10-1.27-13.78-4.72-7.2-6.59-7.71-16-3.12-24a14.6,14.6,0,0,1,8.64-6.89,42.25,42.25,0,0,1,10.77-1.28c22.83-.11,45.66-.05,68.49,0h5.46c2.79-6.79,5.24-13.41,8.23-19.78s6.48-12.38,10-19h-7.55q-44,0-88,0c-8.26,0-14.36-3.18-17.87-10.88-3.38-7.43-1.32-14.16,3.36-19.77,3.53-4.25,8.51-5.58,13.76-5.65q30.21-.43,60.43-.59c4.64,0,9.28.55,13.92.57,4,0,7.95-.5,11.92-.51s8,.43,11.93.47c8.67.08,17.34-.13,26,.1a13,13,0,0,0,9-3.29,140,140,0,0,1,31.46-19.13,177.53,177.53,0,0,1,29.38-9.87c7.63-1.92,15.33-2.45,23-3.6,12.39-1.86,24.77.22,37.14,1.18a11.06,11.06,0,0,1,1.43.42l18.52,4.09c0-13.94,0-27.53,0-41.12s0-27,0-40.5q0-20.5,0-41c0-13.6.07-27.21-.08-41.07H410.09a29.57,29.57,0,0,1-4,0c-5.9-.81-10.81-3.06-14.4-8.29-2.81-4.09-3.51-8.49-3.52-13.05-.1-35-.06-70-.06-105C388.12,40.13,388.12,38.48,388.12,36.27Zm87.68,570a122.31,122.31,0,0,0,107.46-63.76A119.38,119.38,0,0,0,598,484.13,121.76,121.76,0,0,0,476.42,362c-69.5-.16-122,54.66-123,120.63-.51,34.33,11.86,64.3,36.33,88.49C413.45,594.52,442.44,606,475.79,606.32Zm18.74-475c-22.79-22.79-45.37-45.36-68-67.92-.17-.17-.61-.06-.92-.09-.17.28-.46.54-.49.83-.09,1-.12,2-.11,3q.08,32,.18,64a.75.75,0,0,0,.22.41,2.76,2.76,0,0,0,.38.32C438.45,132.61,490.12,132.31,494.54,131.36Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M359.7,286.36q56,0,111.91,0c5.31,0,10.31,1.15,14,5.09,9.15,9.74,6.48,21.19-1.59,28-3.1,2.61-7.32,3.62-11.6,3.6-12,0-24,0-36,0q-94.43,0-188.85,0c-5.58,0-10.61-1.29-14.79-5.58S226.55,304.31,229,298a18.35,18.35,0,0,1,6.93-8.75,19,19,0,0,1,10.32-2.89c2.83,0,5.66,0,8.49,0H359.7Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M359.72,211.09q55,0,110,0c3.8,0,7.48.09,11.17,1.81a18.27,18.27,0,0,1,5.86,28.46c-3.81,4.31-8.53,6-14.06,6q-14.25,0-28.49,0H247.71c-4.88,0-9.39-.86-13.43-4-6.59-5.09-7.37-15.62-5-21.16,3.53-8.41,10.09-11.18,18.51-11.17h112Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M293.93,135.34c15.31,0,30.63,0,45.94,0a19,19,0,0,1,13.85,5.48c5.33,5.23,7.06,13.94,3.9,20.51a18.1,18.1,0,0,1-7.76,8.53c-.87.47-1.84,1.25-2.7,1.18-4.08-.36-7.83,1.74-12.21.64-3.94-1-8.42-.59-12.65-.27-5.42.42-10.82-.32-16.22,0-7.11.37-14.27-.77-21.34.67-13.25-1.51-26.54-.29-39.81-.66-8.36-.24-13.15-3.49-15.92-11.28-2.31-6.51-1.3-14.68,4.74-20,3.83-3.39,8.57-4.77,13.75-4.76C263,135.37,278.45,135.34,293.93,135.34Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M167.16,153.52c-.17-10.85,9.23-20.28,20.66-20,11.21.31,19.7,8,19.91,20.38.2,11.53-9.9,20-20.41,20.4C178.23,174.65,166,164.1,167.16,153.52Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M187.36,435.16a20.31,20.31,0,0,1,20.4,20.36c.06,11.49-8.34,20.23-20.47,20.34-10.92.1-20.09-9.53-20.3-20.52C166.81,445.82,177.46,434.63,187.36,435.16Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M187.35,249.25c-11.16,1.28-20.46-11.06-20.35-20,.11-9.81,8.8-20.32,20.09-20.22,12,.1,20.42,8.75,20.65,20.22C208,240.55,197.48,250.58,187.35,249.25Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M187.71,360.12c11.28,0,19.6,8.53,19.84,19.88a20.15,20.15,0,0,1-20.34,20.34c-11.64-.07-20-10.2-20.19-20.11C166.81,371.3,176.07,358.69,187.71,360.12Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M167.16,304.48a19.79,19.79,0,0,1,20.34-19.94c11.24,0,20.08,8,20,20.37-.11,11.93-8.64,19.81-19.93,19.95A19.82,19.82,0,0,1,167.16,304.48Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M454.73,508.23a25,25,0,0,0,3.06-2.48c6.2-6.85,12.3-13.79,18.52-20.63,5.81-6.4,11.77-12.67,17.58-19.07,7.18-7.91,14.24-15.92,21.4-23.84q9.12-10.09,18.35-20.07c5.84-6.33,13.18-7.83,20.78-4.64a17.66,17.66,0,0,1,10.07,22.07,18.71,18.71,0,0,1-9.19,11.14,3,3,0,0,0-2,2.54c-.12,1-1.05,2-1.65,2.91-1.16,1.86-3.68,2.19-4.44,4.92-.56,2-3.28,3.41-4.95,5.16s-3.29,3.61-4.9,5.45-3.14,3.76-4.79,5.56-3.51,3.53-5.18,5.37-3.2,3.8-4.83,5.68-3.23,3.76-4.91,5.58c-5.75,6.22-11.59,12.37-17.28,18.64-7.17,7.91-14.21,15.94-21.36,23.88S464.85,552,457.74,559.83c-1.75,1.92-3.25,2-5,.07-4.72-5.09-9.39-10.22-14.07-15.34a3,3,0,0,1-.82-1.23c-.77-3.9-4.14-5.92-6.69-8.17A132.62,132.62,0,0,1,420.65,525c-3.4-3.73-6.88-7.38-10.32-11.08q-14.46-15.55-28.91-31.11c-3.49-3.74-4.42-8.14-4.41-13.18a15.93,15.93,0,0,1,5.18-11.86,16.87,16.87,0,0,1,11.48-4.89c6.57-.38,11.42,2.11,15.66,6.68q18.12,19.47,36.27,38.92c2.32,2.5,4.43,5.2,6.69,7.76A19.64,19.64,0,0,0,454.73,508.23Z",
                                className: style_default().dynamic([
                                    [
                                        "d34762758cb20958",
                                        [
                                            props.theme.primaryColor
                                        ]
                                    ]
                                ]) + " " + "cls-1"
                            })
                        ]
                    })
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "d34762758cb20958",
                dynamic: [
                    props.theme.primaryColor
                ],
                children: ".cls-1{fill:".concat(props.theme.primaryColor, "}")
            })
        ]
    }));
};
/* harmony default export */ var regularReportsIcon = (RegularReportIcon);

;// CONCATENATED MODULE: ./components/chrome/layout/header/checkoutHeader.js












function checkoutHeader_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function checkoutHeader_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function checkoutHeader_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function checkoutHeader_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) checkoutHeader_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) checkoutHeader_defineProperties(Constructor, staticProps);
    return Constructor;
}
function checkoutHeader_getPrototypeOf(o) {
    checkoutHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return checkoutHeader_getPrototypeOf(o);
}
function checkoutHeader_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) checkoutHeader_setPrototypeOf(subClass, superClass);
}
function checkoutHeader_possibleConstructorReturn(self, call) {
    if (call && (checkoutHeader_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return checkoutHeader_assertThisInitialized(self);
}
function checkoutHeader_setPrototypeOf(o, p) {
    checkoutHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return checkoutHeader_setPrototypeOf(o, p);
}
var checkoutHeader_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function checkoutHeader_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function checkoutHeader_createSuper(Derived) {
    var hasNativeReflectConstruct = checkoutHeader_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = checkoutHeader_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = checkoutHeader_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return checkoutHeader_possibleConstructorReturn(this, result);
    };
}
var checkoutHeader_config = (0,config["default"])().publicRuntimeConfig;
var CheckoutHeader = /*#__PURE__*/ function(_Component) {
    "use strict";
    checkoutHeader_inherits(CheckoutHeader, _Component);
    var _super = checkoutHeader_createSuper(CheckoutHeader);
    function CheckoutHeader() {
        checkoutHeader_classCallCheck(this, CheckoutHeader);
        return _super.apply(this, arguments);
    }
    checkoutHeader_createClass(CheckoutHeader, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, logo = _props.logo, theme = _props.theme;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    md: 12,
                    className: "d-flex px-0 checkout-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarBrand/* default */.Z, {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(selectByPlatform/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(giveIndia/* default */.Z, {
                                        name: "www",
                                        width: "125",
                                        color: !logo || logo === '' || logo === 'color' ? '' : logo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partnerLogo/* default */.Z, {
                                        name: "wg",
                                        w: "100%",
                                        className: "partner-logo"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-9f40fe1d382c825c" + " " + "checkout-header-items hide-for-mobile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: "auto d-flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(securePaymentsIcon, {
                                                theme: theme,
                                                size: 35
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    marginLeft: '0.5rem',
                                                    alignSelf: 'center'
                                                },
                                                className: "jsx-9f40fe1d382c825c",
                                                children: "Secure Payment"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: "auto d-flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(trustedNGOsIcon, {
                                                theme: theme,
                                                size: 35
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    marginLeft: '0.5rem',
                                                    alignSelf: 'center'
                                                },
                                                className: "jsx-9f40fe1d382c825c",
                                                children: "Trusted NGOs"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: "auto d-flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(longTermImpactIcon, {
                                                theme: theme,
                                                size: 35
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    marginLeft: '0.5rem',
                                                    alignSelf: 'center'
                                                },
                                                className: "jsx-9f40fe1d382c825c",
                                                children: "Long Term Impact"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: "auto d-flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(regularReportsIcon, {
                                                theme: theme,
                                                size: 35
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    marginLeft: '0.5rem',
                                                    alignSelf: 'center'
                                                },
                                                className: "jsx-9f40fe1d382c825c",
                                                children: "Regular Reports"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "9f40fe1d382c825c",
                            children: ".checkout-header{border-bottom:1px solid #dddddd;\nmin-height:70px;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.checkout-header-items img{height:24px;\npadding-right:10px}\n.checkout-header-items img.secure-payment-logo{margin-top:-8px}"
                        })
                    ]
                }));
            }
        }
    ]);
    return CheckoutHeader;
}(react.Component);


;// CONCATENATED MODULE: ./components/chrome/layout/siteChrome.js



// import { Header } from './header';
// import { Footer } from './footer';








function siteChrome_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function siteChrome_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function siteChrome_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function siteChrome_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) siteChrome_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) siteChrome_defineProperties(Constructor, staticProps);
    return Constructor;
}
function siteChrome_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function siteChrome_getPrototypeOf(o) {
    siteChrome_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return siteChrome_getPrototypeOf(o);
}
function siteChrome_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) siteChrome_setPrototypeOf(subClass, superClass);
}
function siteChrome_possibleConstructorReturn(self, call) {
    if (call && (siteChrome_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return siteChrome_assertThisInitialized(self);
}
function siteChrome_setPrototypeOf(o, p) {
    siteChrome_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return siteChrome_setPrototypeOf(o, p);
}
var siteChrome_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function siteChrome_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function siteChrome_createSuper(Derived) {
    var hasNativeReflectConstruct = siteChrome_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = siteChrome_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = siteChrome_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return siteChrome_possibleConstructorReturn(this, result);
    };
}
var SiteChrome = /*#__PURE__*/ function(_Component) {
    "use strict";
    siteChrome_inherits(SiteChrome, _Component);
    var _super = siteChrome_createSuper(SiteChrome);
    function SiteChrome(props) {
        siteChrome_classCallCheck(this, SiteChrome);
        var _this;
        _this = _super.call(this, props);
        siteChrome_defineProperty(siteChrome_assertThisInitialized(_this), "toggleSignUpModal", function() {
            _this.setState({
                signUpOpen: true,
                toggleModal: !_this.state.toggleModal
            });
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEvent('signupClick', {}, {
                    amplitude: true
                });
            }
        });
        siteChrome_defineProperty(siteChrome_assertThisInitialized(_this), "toggleLogInModal", function() {
            _this.setState({
                signUpOpen: false,
                toggleModal: !_this.state.toggleModal
            });
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEvent('loginClick', {}, {
                    amplitude: true
                });
            }
        });
        siteChrome_defineProperty(siteChrome_assertThisInitialized(_this), "toggleSignUpOpen", function() {
            _this.setState({
                signUpOpen: !_this.state.signUpOpen,
                toggleModal: !_this.state.toggleModal
            });
            var eventInfo = {
                transitionTo: _this.state.signUpOpen ? 'login' : 'signup'
            };
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEvent('switchLoginSignup', eventInfo, {
                    amplitude: true
                });
            }
        });
        siteChrome_defineProperty(siteChrome_assertThisInitialized(_this), "toggleModal", function() {
            _this.setState({
                toggleModal: !_this.state.toggleModal
            });
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEvent('closeLoginSignupModal', {}, {
                    amplitude: true
                });
            }
        });
        _this.state = {
            toggleModal: false,
            signUpOpen: false
        };
        var events = {
            on: function on(event, cb, opts) {
                if (!_this.namespaces) {
                    _this.namespaces = {};
                }
                _this.namespaces[event] = cb;
                var options = opts || false;
                _this.addEventListener && _this.addEventListener(event.split('.')[0], cb, options);
                return siteChrome_assertThisInitialized(_this);
            },
            off: function off(event) {
                _this.removeEventListener(event.split('.')[0], _this.namespaces[event]);
                delete _this.namespaces[event];
                return siteChrome_assertThisInitialized(_this);
            }
        };
        // Extend the DOM with these above custom methods
        if (window) {
            window.on = Element.prototype.on = events.on;
            window.off = Element.prototype.off = events.off;
        }
        return _this;
    }
    siteChrome_createClass(SiteChrome, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, logo = _props.logo, backgroundColor = _props.backgroundColor, session = _props.session, stickyTop = _props.stickyTop, fixedTop = _props.fixedTop, navHeight = _props.navHeight, color = _props.color, pageType = _props.pageType, tenantConfig = _props.tenantConfig, mainStyle = _props.mainStyle, children = _props.children, width = _props.width, forceToggle = _props.forceToggle, footerLogo = _props.footerLogo, hideSearch = _props.hideSearch, hideOldplatformStrip = _props.hideOldplatformStrip, partner = _props.partner, stickySecondSubMenu = _props.stickySecondSubMenu, subdomain = _props.subdomain, hideLogin = _props.hideLogin, hideMainMenu = _props.hideMainMenu, loginBackgroundColor = _props.loginBackgroundColor, hideOldPlatformLink = _props.hideOldPlatformLink, hideHeaderOnScroll = _props.hideHeaderOnScroll, headerShadow = _props.headerShadow;
                var openFlag = this.state.toggleModal;
                if (forceToggle) {
                    openFlag = this.state.toggleModal !== this.props.forceToggle;
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: this.props.chromeStyle,
                            children: [
                                this.props.source !== 'sqrrl' ? pageType !== 'checkout' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {
                                    session: session,
                                    toggleSignUpModal: this.toggleSignUpModal,
                                    toggleLogInModal: this.toggleLogInModal,
                                    backgroundColor: backgroundColor || 'white',
                                    color: color,
                                    logo: logo,
                                    stickyTop: stickyTop,
                                    fixedTop: fixedTop,
                                    navHeight: navHeight,
                                    width: width,
                                    hideSearch: hideSearch,
                                    partner: partner,
                                    stickySecondSubMenu: stickySecondSubMenu,
                                    hideMainMenu: hideMainMenu,
                                    _csrf: this.props._csrf,
                                    loginBackgroundColor: loginBackgroundColor,
                                    hideOldPlatformLink: hideOldPlatformLink,
                                    tenantConfig: tenantConfig,
                                    hideLogin: hideLogin,
                                    pageType: pageType,
                                    subdomain: subdomain,
                                    hideHeaderOnScroll: hideHeaderOnScroll,
                                    headerShadow: headerShadow
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutHeader, {
                                    theme: tenantConfig.theme
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-bfd13f5ba7c42497" + " " + "header-for-sqrrl",
                                    children: (0,jsx_runtime.jsx)((style_default()), {
                                        id: "bfd13f5ba7c42497",
                                        children: ".header-for-sqrrl{width:100%;\n-webkit-transform:skewy(-6deg);\n-moz-transform:skewy(-6deg);\n-ms-transform:skewy(-6deg);\ntransform:skewy(-6deg);\ntop:-75px;\nleft:0;\nbackground:#13253b;\nposition:absolute;\nheight:160px}\nhtml{overflow-y:scroll}\nbody{background:#ACAEA9;\noverflow-y:scroll}\nhtml{overflow-y:scroll}\nbody{background:#acaea9;\noverflow-y:scroll}"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                    style: mainStyle,
                                    className: "jsx-4434892b71a2bd63" + " " + "".concat(width > 768 ? 'sc-desktop-padding-style' : 'sc-mobile-padding-style'),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-4434892b71a2bd63",
                                            children: children
                                        }),
                                        (0,jsx_runtime.jsx)((style_default()), {
                                            id: "4434892b71a2bd63",
                                            children: ".sc-desktop-padding-style{padding-top:64px}\n.sc-mobile-padding-style{padding-top:64px}"
                                        })
                                    ]
                                }),
                                this.props.source !== "sqrrl" ? pageType !== 'checkout' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(selectComponent/* default */.Z, {
                                    name: (0,selectPlatform/* default */.Z)(subdomain),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                            pageType: pageType,
                                            session: session,
                                            logo: footerLogo,
                                            name: "www",
                                            tenantConfig: this.props.tenantConfig
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WGFooter_Footer, {
                                            name: "wg",
                                            subdomain: subdomain,
                                            tenantConfig: tenantConfig
                                        })
                                    ]
                                }) : null : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signInModal/* default */.Z, {
                            session: session,
                            isOpen: openFlag,
                            isSignUpOpen: this.state.signUpOpen,
                            toggleModal: this.toggleModal,
                            toggleSignUpOpen: this.toggleSignUpOpen,
                            _csrf: this.props._csrf
                        })
                    ]
                }));
            }
        }
    ]);
    return SiteChrome;
}(react.Component);
/* harmony default export */ var siteChrome = ((0,react_contextual_es/* subscribe */.Ld)()(SiteChrome));


/***/ }),

/***/ 80161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_contextual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80224);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);




var config = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])().publicRuntimeConfig;
var PartnerLogo = function(param) {
    var w = param.w, subdomain = param.subdomain, className = param.className, tenantConfig = param.tenantConfig;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        width: tenantConfig.header.logo.width || w,
        alt: 'Logo',
        src: "".concat(config.cdnUrl, "/static/images/wg/partners/logos/").concat(subdomain, ".png"),
        className: className
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_contextual__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)()(PartnerLogo));


/***/ }),

/***/ 93220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chrome_elements_selectComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67130);
/* harmony import */ var _util_selectPlatform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41395);
/* harmony import */ var react_contextual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80224);





var SelectByPlatform = function(param) {
    var subdomain = param.subdomain, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chrome_elements_selectComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        name: (0,_util_selectPlatform__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(subdomain),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_contextual__WEBPACK_IMPORTED_MODULE_4__/* .subscribe */ .Ld)()(SelectByPlatform));


/***/ }),

/***/ 41395:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var selectPlatform = function(subdomain) {
    if (typeof subdomain === 'undefined' || subdomain === '' || subdomain === 'www') {
        return 'www';
    }
    return 'wg';
};
/* harmony default export */ __webpack_exports__["Z"] = (selectPlatform);


/***/ })

}]);